import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Avatar,
  Autocomplete,
  Chip,
  CircularProgress,
  Stack,
  Grid,
  Button,
  Tabs,
  Tab,
  Divider,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  InputLabel, 
  Select,
  MenuItem,
  TablePagination,
  TableContainer,
  FormControlLabel,
  Checkbox ,
  FormHelperText 
 
} from "@mui/material";

import {
  Person,
  Search,
  LocalHospital,
  Science,
  Notes,
  LocalPharmacy,
  CalendarMonth,
  Print,
  Send,
  History,
  Close,
  Scanner,
  Medication,
  RoomService,
  Hotel,
  PersonAdd ,
   AutoAwesome ,
   CameraAlt ,Delete,
  Info
} from "@mui/icons-material";


import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Tooltip } from "@mui/material";
import { suggestionsData } from "../data/suggestionsData";
import { diagnosisRules } from "../data/diagnosisRules";
import SaveIcon from "@mui/icons-material/Save";
import { Edit } from "@mui/icons-material";
import { ErrorMessage, successMessage ,frequencyMap ,frequencyMultiplier ,standardFrequencies ,MEDICATION_ROUTES} from "../Message";
import { isAdultFromDobOrAge } from "../../utils/age";

import {loadInsuredServicesdb ,loadDoctorSuggestionsdb ,loadPatientDiagnosisdb 
  ,servicesToday ,saveServiceProvideddb ,saveOrUpdateDiagnosisdb ,loadDiagnosisOptionsdb ,loadProcedureOptionsdb ,
  saveOrUpdateDiagnosisDocumetingdb ,saveOrUpdateProceduresDocumetingdb ,loadLabdb ,requestLab ,loadRequestedLabsdb
 ,deleteRequestedLabdb ,loadAvailableScansdb ,loadRequestedScandb ,loadMedicationsdb ,addMedicationdb , loadRequestedMedsdb 
  ,updateMedicationdb ,medicationdeletedb ,loadOtherServicesdb ,requestOtherService ,loadRequestedOtherServicesdb ,saveAppointmentdb, 
  loadAppointmentsdb, updateAppointmentdb, deleteAppointmentdb ,getPatientAppointmentdb ,admitPatient ,loadMedicationByAge ,outpatientStatsdb 

  ,deleteOrReverseOtherServicedb ,saveChronicMedication , loadChronicMedicationdb ,medicationStock ,scheduleAppointmentSms

   ,outpatientMonthsdb, outpatientDatesdb, outpatientPatientsdb , loadLabTestParameters, loadParameterDetails, saveLabResults, 
   loadLabResults, loadPharmacyInfo, deleteResultC , loadScanParameters as loadScanParametersAPI, saveScanResults, 
   loadExistingScanResults ,loadWardRoundsdb ,generateNote  } from '../BaseURL';


import Swal from "sweetalert2";
import { formatWithOutSom } from "../Message";
import MedicalHistoryDialog from "../Doctors/MedicalHistoryDialog";
import LabHistoryDialog from "../Doctors/LabHistoryDialog";
import ScanHistoryDialog from "../Doctors/ScanHistoryDialog";
import MedicationHistory from "../Pharmacy/MedicationHistory";
import VitalsHistoryDialog from "../Doctors/VitalsHistoryDialog";
import SpecialPrecautionDialog from "../Doctors/SpecialPrecautionDialog";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ChronicMedicationDialog from "../Doctors/ChronicMedicationDialog";
import WardRoundsDialog from "../Doctors/WardRoundsDialog";
import OutPatientWardRoundsDialog from "./OutPatientWardRoundsDialog";
import moment from "moment";


const OutPatient = () => {
 
  const [outpatientStats, setOutpatientStats] = useState({
  totalOutpatients: 0,
  maleCount: 0,
  femaleCount: 0,
  pediatricsCount: 0,
  adultCount: 0
});
  const [loading, setLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
 
  const [activeTab, setActiveTab] = useState(0);
  const [allPatients ,setAllPatients] = useState([]);

const [serviceProvided, setServiceProvided] = useState('');
const [attendanceType, setAttendanceType] = useState('');
const [precautionDialogOpen, setPrecautionDialogOpen] = useState(false);
const [doseAmount, setDoseAmount] = useState("");
const [doseUnit, setDoseUnit] = useState("");
const [medSearchTerm, setMedSearchTerm] = useState("");
const [selectedMed, setSelectedMed] = useState(null);
const [dose, setDose] = useState("");
const [frequency, setFrequency] = useState("");
const [days, setDays] = useState("");
const [qty, setQty] = useState(0);
const [route, setRoute] = useState("");
const [requestedMeds, setRequestedMeds] = useState([]);
const [autoCalculate, setAutoCalculate] = useState(true);
const [chronicDialogOpen, setChronicDialogOpen] = useState(false);
const [chronicMeds, setChronicMeds] = useState([]);

const [wardRoundsOpen, setWardRoundsOpen] = useState(false);
const [wardRoundsData, setWardRoundsData] = useState([]);

// Manual service request
const [manualServiceName, setManualServiceName] = useState("");
const [manualQty, setManualQty] = useState(1);
const [manualAmount, setManualAmount] = useState("");

const [isLoadingDiagnosis, setIsLoadingDiagnosis] = useState(false);

const [medInfoDialogOpen, setMedInfoDialogOpen] = useState(false);
const [selectedMedInfo, setSelectedMedInfo] = useState(null);
const [medInfoLoading, setMedInfoLoading] = useState(false);


// --- Filter States (NEW) ---
const [outpatientMonths, setOutpatientMonths] = useState([]);
const [selectedMonth, setSelectedMonth] = useState('');
const [outpatientDates, setOutpatientDates] = useState([]);
const [selectedDate, setSelectedDate] = useState('');
const [loadingMonths, setLoadingMonths] = useState(false);
const [loadingDates, setLoadingDates] = useState(false);
const [loadingPatients, setLoadingPatients] = useState(false);
const [patientSearchTerm, setPatientSearchTerm] = useState('');


const [stateFilter, setStateFilter] = useState('all')

// Patient table pagination
const [patientPage, setPatientPage] = useState(0);
const [patientRowsPerPage, setPatientRowsPerPage] = useState(10);

const [filterExpanded, setFilterExpanded] = useState(true);


const [labResultsDialogOpen, setLabResultsDialogOpen] = useState(false);
const [selectedLabForResults, setSelectedLabForResults] = useState(null);
const [testParameters, setTestParameters] = useState([]);
const [selectedParameter, setSelectedParameter] = useState(null);
const [parameterResult, setParameterResult] = useState('');
const [parameterFlag, setParameterFlag] = useState('Select/Enter');
const [enteredResults, setEnteredResults] = useState([]);
const [loadingParameters, setLoadingParameters] = useState(false);
const [loadingParameterDetails, setLoadingParameterDetails] = useState(false);
const [testCategory, setTestCategory] = useState('');
const [availableFlags, setAvailableFlags] = useState(['Select/Enter']);
const [editingResultIndex, setEditingResultIndex] = useState(null);
const [generalComment, setGeneralComment] = useState('');
const [companyInfo, setCompanyInfo] = useState(null);

const [serviceTypeFilter, setServiceTypeFilter] = useState('');
const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
const [loadingServiceTypes, setLoadingServiceTypes] = useState(false);



// Scan Results Entry States
const [scanResultsDialogOpen, setScanResultsDialogOpen] = useState(false);
const [selectedScanForResults, setSelectedScanForResults] = useState(null);
const [scanTestParameters, setScanTestParameters] = useState([]);
const [selectedScanParameter, setSelectedScanParameter] = useState(null);
const [scanParameterResult, setScanParameterResult] = useState('');
const [scanParameterFlag, setScanParameterFlag] = useState('-');
const [enteredScanResults, setEnteredScanResults] = useState([]);
const [loadingScanParameters, setLoadingScanParameters] = useState(false);
const [scanCategory, setScanCategory] = useState('');
const [availableScanFlags, setAvailableScanFlags] = useState(['-']);
const [editingScanResultIndex, setEditingScanResultIndex] = useState(null);
const [scanGeneralComment, setScanGeneralComment] = useState('');
// ─── OPD AI Note Generation ───────────────────────────────────────
const [aiGeneratingOPDNote, setAiGeneratingOPDNote]   = useState(false);
const [aiOPDIncludeOther,   setAiOPDIncludeOther]     = useState(false);
const [aiOPDNoteGenCount,   setAiOPDNoteGenCount]     = useState(0);


// --- Load Available Months ---
const loadOutpatientMonths = async () => {
  setLoadingMonths(true);
  try {
    const response = await axios.get(outpatientMonthsdb);
    setOutpatientMonths(response.data || []);
  } catch (error) {
    console.error('Failed to load outpatient months:', error);
  } finally {
    setLoadingMonths(false);
  }
};



const loadServiceTypes = async () => {
  setLoadingServiceTypes(true);
  try {
    const response = await axios.get(outpatientPatientsdb, {
      params: { month: selectedMonth, date: selectedDate || undefined, distinctServices: true }
    });
    // Extract unique service names from loaded patients
    // OR call a dedicated endpoint — adjust to your backend
    if (response.data.success) {
      const unique = [...new Set(
        (response.data.results || [])
          .map(p => p.serviceName || p.service || p.ins_service)
          .filter(Boolean)
      )].sort();
      setServiceTypeOptions(unique);
    }
  } catch (error) {
    console.error('Failed to load service types:', error);
  } finally {
    setLoadingServiceTypes(false);
  }
};

// --- Load Dates for Selected Month ---
const loadOutpatientDates = async (month) => {
  if (!month) {
    setOutpatientDates([]);
    setSelectedDate('');
    return;
  }
  setLoadingDates(true);
  try {
    const response = await axios.get(outpatientDatesdb, {
      params: { month }
    });
    setOutpatientDates(response.data || []);
  } catch (error) {
    console.error('Failed to load outpatient dates:', error);
  } finally {
    setLoadingDates(false);
  }
};

// --- Load Patients by Month/Date ---
const loadPatientsByFilter = async (month, date) => {
  if (!month) {
    setAllPatients([]);
    return;
  }
  setLoadingPatients(true);
  try {
    const response = await axios.get(outpatientPatientsdb, {
      params: { month, date: date || undefined }
    });
    if (response.data.success) {
      setAllPatients(response.data.results);
    } else {
      setAllPatients([]);
    }
  } catch (error) {
    console.error('Failed to load patients:', error);
    setAllPatients([]);
  } finally {
    setLoadingPatients(false);
  }
};



const loadWardRoundsData = async () => {
  if (!selectedPatient) return;
  try {
    const res = await axios.get(loadWardRoundsdb, {
      params: {
        patientId: selectedPatient.id,
        startDate: selectedPatient.visitDate
      }
    });
    if (res.data.success) {
      setWardRoundsData(res.data.data);
    }
  } catch (error) {
    console.error("Error loading ward rounds:", error);
  }
};

const handleWardRoundsClose = () => {
  setWardRoundsOpen(false);
  // Reload patient data after ward rounds changes
  if (selectedPatient) {
    loadRequestedLabs();
    loadRequestedScan();
    loadRequestedMeds();
    loadrequestedServices();
  }
};

useEffect(() => {
  if (selectedPatient && (selectedPatient.state === 'inpatient' || selectedPatient.state === 'InPatient' || selectedPatient.state === 'inPatient')) {
    loadWardRoundsData();
  }
}, [selectedPatient]);


const loadOutpatientStats = async () => {
  try {
    const response = await axios.get(outpatientStatsdb);
    
    if (response.data.success) {
      setOutpatientStats({
        totalOutpatients: response.data.total || 0,
        maleCount: response.data.male || 0,
        femaleCount: response.data.female || 0,
        pediatricsCount: response.data.pediatrics || 0,
        adultCount: response.data.adult || 0
      });
    }
  } catch (error) {
    console.error("Error loading outpatient stats:", error);
  }
}


useEffect(() => {
  const loadCompanyInfo = async () => {
    try {
      const response = await fetch(loadPharmacyInfo);
      const data = await response.json();
      if (data.success && data.results) {
        setCompanyInfo(data.results);
      }
    } catch (error) {
      console.error('Error loading company info:', error);
    }
  };
  loadCompanyInfo();
}, []);


useEffect(() => {
  loadOutpatientMonths();

  const savedUserInfo = localStorage.getItem('userInfo');
  if (savedUserInfo) {
    const userInfo = JSON.parse(savedUserInfo);
    const userName = userInfo.name || '';
    setcurrentUser(userName);
    if (userName) loadDoctorSuggestions(userName);
  }
}, []);

// --- Effect: Load dates when month changes ---
useEffect(() => {
  if (selectedMonth) {
    loadOutpatientDates(selectedMonth);
    setSelectedDate('');
    setPatientPage(0);
    setServiceTypeFilter('');  // ← add this
  } else {
    setOutpatientDates([]);
    setSelectedDate('');
    setAllPatients([]);
    setServiceTypeFilter('');  // ← add this
  }
}, [selectedMonth]);



useEffect(() => {
  loadOutpatientStats();
  
  // Refresh stats every 30 seconds
  const interval = setInterval(() => {
    loadOutpatientStats();
  }, 30000);

  return () => clearInterval(interval);
}, []);



useEffect(() => {
  if (selectedMonth) {
    loadPatientsByFilter(selectedMonth, selectedDate);
    setPatientPage(0);
  }
}, [selectedMonth, selectedDate]);

// Derive service type options from loaded patients
useEffect(() => {
  if (allPatients.length > 0) {
    const unique = [...new Set(
      allPatients
        .map(p => p.service_type)
        .filter(s => s && s.trim() !== '')
    )].sort();
    setServiceTypeOptions(unique);
  } else {
    setServiceTypeOptions([]);
    setServiceTypeFilter('');
  }
}, [allPatients]);


const [medHistoryOpen, setMedHistoryOpen] = useState(false);
const [labHistoryOpen, setlabHistoryOpen] = useState(false);
const [ScanHistoryOpen, setScanHistoryOpen] = useState(false);
const [openmedHis, setopenmedHis] = useState(false);
const [vitalsHistoryOpen, setVitalsHistoryOpen] = useState(false);


const [complaint, setComplaint] = useState("");
const [history, setHistory] = useState("");
const [exam, setExam] = useState("");
const [other, setOther] = useState("");


const ensureServiceAndAttendanceSelected = () => {
  if (!serviceProvided || !attendanceType) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please select both 'Service Provided' and 'Type of Attendance' before proceeding.",
    });
    return false;
  }
  return true;
};


const [currentUser ,setcurrentUser]=useState()



const [diagnosisOptions, setDiagnosisOptions] = useState([]);
const [procedureOptions ,setprocedureOptions]= useState([])
const [procedureOptionsLoaded, setProcedureOptionsLoaded] = useState(false);


const loadDiagnosisOptions = async (age , gender , status)  => {
   setLoading(true);
  try {
    const response = await axios.get(loadDiagnosisOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setDiagnosisOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};


const loadProcedureOptions = async (age , gender , status)  => {
 
   setLoading(true);
  try {
    const response = await axios.get(loadProcedureOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setprocedureOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  } finally {
    setLoading(false);
    setProcedureOptionsLoaded(true);
  }
};

const [customSuggestions, setCustomSuggestions] = useState({});

const loadDoctorSuggestions = async (doctorName) => {
   setLoading(true);
  try {
    const response = await axios.get(loadDoctorSuggestionsdb, {
      params: { doctorName }
    });

    if (response.data.success) {
      setCustomSuggestions(response.data.data);

      // ✅ Merge backend doctor suggestions with local suggestionsData
      Object.keys(response.data.data).forEach((field) => {
        const backendItems = response.data.data[field] || [];
        const merged = [
            ...new Set([...backendItems, ...suggestionsData[field]])
        ];
        suggestionsData[field] = merged; // extend in-memory data
      });

      console.log("Updated suggestionsData with backend doctor data:", suggestionsData);
    }
  } catch (error) {
    console.error("Error loading doctor suggestions:", error);
  }finally {
    setLoading(false);
  }
};

const loadServiceAndAttendance = async (patientId , dat) => {
 setLoading(true);
  try {
    const response = await axios.get(servicesToday, {
      params: { patient_id: patientId , dat:dat }
    });

    if (response.data.success && response.data.data) {
      const { name, att } = response.data.data;
      setServiceProvided(name || '');
      setAttendanceType(att || '');
    } else {
      setServiceProvided('');
      setAttendanceType('');
    }
  } catch (error) {
    console.error('Error loading service and attendance:', error);
  }finally {
    setLoading(false);
  }
};


const [insuredServices, setInsuredServices] = useState([]);

const loadInsuredServices = async (insuranceName, patientAge) => {
  setLoading(true);
  try {
  
    const response = await axios.get(loadInsuredServicesdb, {
      params: {
        STATUS: insuranceName,
        charge_status: "Main Services",
        patientAge: patientAge, // 👈 send age here
      },
    });

    if (response.data.success) {
      setInsuredServices(response.data.results);
      console.log("Loaded insured services:", response.data.results);
    } else {
      setInsuredServices([]);
    }
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || "Failed to load insured services",
      icon: "error",
    });
  }finally {
    setLoading(false);
  }
};

const loadChronicMedication = async () => {
  if (!selectedPatient) return [];

  try {
    const res = await axios.get(loadChronicMedicationdb, {
      params: { patientId: selectedPatient.id }
    });

    if (res.data.success) {
      console.log("✅ Chronic meds loaded:", res.data.medications);
      setChronicMeds(res.data.medications);

      // Auto-open dialog only if meds exist
      if (res.data.medications.length > 0) {
        setChronicDialogOpen(true);
      }
      
      return res.data.medications; // ✅ Return the data
    }
    
    return [];
  } catch (err) {
    console.log("Error loading chronic meds:", err);
    return [];
  }
};




// when patient is selected, load services automatically
useEffect(() => {
  if (selectedPatient) {
    setProcedureOptionsLoaded(false);
    setActiveTab(0);
    
    // ✅ Create async function to ensure proper order
    const loadPatientData = async () => {
      // ✅ Step 1: Load chronic medications FIRST and wait
      const chronicMedsData = await loadChronicMedication();
      
      // ✅ Step 2: Load everything else (order doesn't matter for these)
      loadInsuredServices(selectedPatient.insurance, selectedPatient.age);
      
      loadServiceAndAttendance(selectedPatient.id, selectedPatient.visitDate);
      loadDiagnosisOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance);
      loadProcedureOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance);
      loadLabs();
      loadRequestedLabs();
      loadAvailableScans();
      loadRequestedScan();
      
      // ✅ Step 3: Pass chronic data directly to loadMedications
      loadMedications(chronicMedsData);
      
      loadRequestedMeds();
      loadOtherServices();
      loadrequestedServices();
      loadPatientAppointments();
    };
    
    // Execute the async loading
    loadPatientData();
     
    if (selectedPatient.PrecautionType && selectedPatient.PrecautionType.trim() !== '') {
      setPrecautionDialogOpen(true);
    }
  }
}, [selectedPatient]);



useEffect(() => {
  if (
    selectedPatient &&
    selectedPatient.id &&
    diagnosisOptions.length > 0 &&
    procedureOptionsLoaded
  ) {
    console.log("Loading diagnosis with options ready");
    loadPatientDiagnosis(selectedPatient.id, selectedPatient.visitDate);
  }
}, [diagnosisOptions, procedureOptionsLoaded, selectedPatient]);


const [hasEdited, setHasEdited] = useState(false);
const [Diagnosis, setDiagnosis] = useState();
const [procedure_, setprocedure_] = useState();


const loadPatientDiagnosis = async (patientId, dat) => {
  setLoading(true);
  setIsLoadingDiagnosis(true); // ⭐ block autosave

  try {
    const response = await axios.get(loadPatientDiagnosisdb, {
      params: { patientId, dat },
    });

    // ❌ DON'T clear immediately anymore
    // Clearing causes autosave("") bug

    if (!response.data.success || !response.data.data) {
      // Only clear AFTER fetch completes
      setComplaint("");
      setHistory("");
      setExam("");
      setOther("");
      setSelectedDiagnoses([]);
      setSelectedProcedures([]);
      setHasEdited(false);
      return;
    }

    const { complaint, history, exam, other, documenting, procedure_ } =
      response.data.data;

    // ✅ Load text safely
    setComplaint(complaint || "");
    setHistory(history || "");
    setExam(exam || "");
    setOther(other || "");

    setDiagnosis(documenting);
    setprocedure_(procedure_);

    // ---------- Diagnoses ----------
    if (documenting?.trim()) {
      const parsed = documenting.split(",").map(x => x.trim());

      const matched = diagnosisOptions.filter(opt =>
        parsed.some(p => opt.name.toLowerCase() === p.toLowerCase())
      );

      setSelectedDiagnoses(matched);
    } else {
      setSelectedDiagnoses([]);
    }

    // ---------- Procedures ----------
    if (procedure_?.trim()) {
      const parsed = procedure_.split(",").map(x => x.trim());

      const matched = procedureOptions.filter(opt =>
        parsed.some(p => opt.name.toLowerCase() === p.toLowerCase())
      );

      setSelectedProcedures(matched);
    } else {
      setSelectedProcedures([]);
    }

    setHasEdited(false); // ⭐ important
  } catch (error) {
    console.error("Error loading diagnosis:", error);
  } finally {
    setIsLoadingDiagnosis(false); // ⭐ unblock autosave
    setLoading(false);
  }
};

// ✅ Debounced autosave for complaint, history, exam, other
useEffect(() => {
  if (!selectedPatient || !selectedPatient.id) return;

  // ⭐ CRITICAL FIX
  if (!hasEdited || isLoadingDiagnosis) return;

  const saveTimer = setTimeout(async () => {
    try {
      await axios.post(saveOrUpdateDiagnosisdb, {
        patientId: selectedPatient.id,
        dat: selectedPatient.visitDate,
        complaint,
        history,
        exam,
        other,
        currentUser,
      });

      console.log("✅ Auto-saved successfully");
    } catch (error) {
      console.error("❌ Auto-save failed:", error);
    }
  }, 1000);

  return () => clearTimeout(saveTimer);
}, [
  complaint,
  history,
  exam,
  other,
  selectedPatient,
  hasEdited,
  isLoadingDiagnosis   // ⭐ must be dependency
]);


const saveServiceProvided = async (
  updateConfirmed = false,
  customType = null,
  customService = null
) => {
  // ✅ Use either passed values or current state
   setLoading(true);
  const finalAttendanceType = customType || attendanceType;
  const finalServiceProvided = customService || serviceProvided;

  // ✅ Keep backup of previous state
  const previousService = serviceProvided;
  const previousType = attendanceType;

  const selectedService = insuredServices.find(
    (s) => s.name === finalServiceProvided
  );

  try {
    const response = await axios.post(saveServiceProvideddb, {
      patient_id: selectedPatient.id,
      dat: selectedPatient.visitDate,
      service_name: finalServiceProvided,
      attendance_type: finalAttendanceType,
      insurance: selectedPatient.insurance,
      code: selectedService?.code || "",
      toup: selectedService?.toup || 0,
      amo: selectedService?.amo || 0,
      unin: selectedService?.unin || 0,
      currentUser,
      patientName: selectedPatient.fullName,
      updateConfirmed,
    });

    // 🔹 When service or attendance already exists for today
    if (response.data.exists) {
      const result = await Swal.fire({
        title: "Update Today's Record?",
        text: `A record for '${finalServiceProvided}' (${finalAttendanceType}) already exists today. Do you want to update it?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, update it",
        cancelButtonText: "No, keep existing",
      });

      if (result.isConfirmed) {
        // ✅ Proceed with update
        await saveServiceProvided(true, finalAttendanceType, finalServiceProvided);
      } else {
        // ❌ Revert both service and attendance type to previous values
        setServiceProvided(previousService);
        setAttendanceType(previousType);

        Swal.fire(
          "No Changes Made",
          `Existing Type of Attendance kept (${previousType}).`,
          "info"
        );
      }

      return;
    }

    // 🔹 Success message
    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
        timer: 1500,
        showConfirmButton: false,
      });
    }
  } catch (error) {
    console.error("Error saving service:", error);
    Swal.fire("Error", "Unable to save service information.", "error");
  }finally {
    setLoading(false);
  }
};

// ✅ Debounced autosave for complaint, history, exam, other
useEffect(() => {
  if (!autoCalculate) return; // if OFF, skip auto calculation

  // Convert doseAmount to number (it's stored as string from TextField)
  const numericDoseAmount = parseFloat(doseAmount) || 0;

  const nextQty = computeQty({
    doseAmount: numericDoseAmount,
    doseString: dose,
    days,
    frequency,
    doseUnit,
    normalizeFrequencyFn: normalizeFrequency,
    freqMultiplierMap: frequencyMultiplier,
  });
  setQty(nextQty);
}, [doseAmount, dose, days, frequency, doseUnit, autoCalculate]);


// ✅ Save or update diagnosis for a patient
const saveOrUpdateDiagnosis = async (selectedDiagnosesList) => {
  if (!selectedPatient || !selectedPatient.id) {
    console.warn("⚠️ No patient selected — cannot save diagnosis.");
    return;
  }

   setLoading(true);

  try {
    const response = await axios.post(saveOrUpdateDiagnosisDocumetingdb, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      selectedDiagnoses: selectedDiagnosesList,
      gen:selectedPatient.gender,
      fullName:selectedPatient.fullName,
      age:selectedPatient.age,
      tel:selectedPatient.tel,
      dob: selectedPatient.dob ,
      patientStatus:selectedPatient.state
    });

    if (response.data.success) {
     
    } 
  } catch (error) {
    console.error("❌ Error saving diagnosis:", error);
  }finally {
    setLoading(false);
  }
};

const saveOrUpdateProcedure = async (selectedProceduresList) => {
  if (!selectedPatient || !selectedPatient.id) {
    console.warn("⚠️ No patient selected — cannot save procedures.");
    return;
  }
 setLoading(true);
  try {
    const response = await axios.post(saveOrUpdateProceduresDocumetingdb, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      selectedProcedures: selectedProceduresList,
      gen: selectedPatient.gender,
      fullName: selectedPatient.fullName,
      age: selectedPatient.age,
      tel: selectedPatient.tel,
      dob: selectedPatient.dob,
      patientStatus: selectedPatient.state,
      currentUser: currentUser
    });

    if (response.data.success) {
      
      

      // ✅ CHECK FOR REVERSAL MESSAGES RETURNED BY BACKEND
      if (Array.isArray(response.data.reversals) && response.data.reversals.length > 0) {
        response.data.reversals.forEach((r) => {
         
          ErrorMessage('REVERSAL REQUIRED' ,  `⚠️ REVERSAL REQUIRED\n\nProcedure: ${r.procedure}\nMessage: ${r.message}`)
        });
      }

    } else {
      console.warn("⚠️ Procedure save failed:", response.data.message);
    }

  } catch (error) {
    console.error("❌ Error saving procedures:", error);
  }finally {
    setLoading(false);
  }
};

  // --- AI Analysis logic ---
const analyzeVitals = (vitals) => {
    const { temperature, bp, pulse, respiration, bmi } = vitals;
    const temp = parseFloat(temperature);
    const [systolic, diastolic] = bp.split("/").map(Number);
    const pulseNum = parseInt(pulse);
    const respNum = parseInt(respiration);
    const bmiNum = parseFloat(bmi);

    let remarks = [];

    if (temp > 37.5) remarks.push("Slight fever detected");
    else if (temp < 36) remarks.push("Below normal temperature");

    if (systolic > 130 || diastolic > 85)
      remarks.push("Elevated blood pressure");
    else if (systolic < 90 || diastolic < 60)
      remarks.push("Low blood pressure");

    if (pulseNum > 100) remarks.push("High pulse rate");
    else if (pulseNum < 60) remarks.push("Bradycardia (slow heart rate)");

    if (respNum > 20) remarks.push("High respiration rate");

    if (bmiNum > 25) remarks.push("Overweight BMI");
    else if (bmiNum < 18.5) remarks.push("Underweight BMI");

    if (remarks.length === 0)
      remarks.push("All vitals within normal clinical range");

    return remarks.join("; ") + ".";
};


// AI Suggestion State & Logic
const [suggestions, setSuggestions] = useState({});

const handleSuggest = (field, value, ageGroup = "adult") => {
  if (!value.trim()) return;

  // Get the most recent phrase (after comma or period)
  const phrases = value.split(/[.,]/);
  const currentPhrase = phrases[phrases.length - 1].trim();
  if (!currentPhrase) return;

  // Suggestion based on last phrase
  const fieldSuggestions = suggestionsData[field];
  let match =
    fieldSuggestions?.find((item) =>
      item.toLowerCase().includes(currentPhrase.toLowerCase())
    ) || "";

  // Smart diagnosis + procedure inference
  const lower = currentPhrase.toLowerCase();
  const matchedRules = diagnosisRules.filter(
    (rule) =>
      (rule.ageGroup === ageGroup || rule.ageGroup === "both") &&
      rule.keywords.some((k) => lower.includes(k))
  );
  const diagnoses = [...new Set(matchedRules.flatMap((r) => r.possibleDiagnosis))];
  const procedures = [...new Set(matchedRules.flatMap((r) => r.suggestedProcedures))];

  // Update local state
  setSuggestions((prev) => ({
    ...prev,
    [field]: match,
    [`${field}Diagnosis`]: diagnoses,
    [`${field}Procedures`]: procedures,
  }));
};


//Lab

const [labs, setLabs] = useState([]);
const [labSearchTerm, setLabSearchTerm] = useState("");
const [requestedLabs, setRequestedLabs] = useState([]);


const loadLabs = async () => {
  if (!selectedPatient) return;
   setLoading(true);
  try {
    const response = await axios.get(loadLabdb, {
      params: { insurance: selectedPatient.insurance }
    });

    if (response.data.success) { 
      setLabs(response.data.results);

     

    }
  } catch (error) {
    console.error("Failed to load labs:", error);
  }finally {
    setLoading(false);
  }
};



const handleRequestLab = async (lab) => {
  // ✅ Simply check if the same lab exists in today's request list
 
  const alreadyRequested = requestedLabs.some(
    (r) => r.lab === lab.name
  );

  if (alreadyRequested) {
    ErrorMessage(
      "Already Requested",
      `${lab.name} has already been requested today.`
    );
    return;
  }
 setLoading(true);

  try {
    const response = await axios.post(requestLab, {
      patientId: selectedPatient.id,
      dat:selectedPatient.visitDate,
      patientInsurance: selectedPatient.insurance,
      labName: lab.name,
      amount: lab.amount,
      base_cost: lab.base_cost,
      code: lab.code,
      currentUser ,
      type:'Lab' ,
      waiting_time: lab.waiting_time
    });

    if (response.data.success) {
      loadRequestedLabs();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request lab");
  }finally {
    setLoading(false);
  }
};


const loadRequestedLabs = async () => {
  if (!selectedPatient || !selectedPatient.id) return;

  setLoading(true);
  try {
    const response = await axios.get(loadRequestedLabsdb, {
      params: {
        patientId: selectedPatient.id,
        dat:selectedPatient.visitDate
      },
    });

    if (response.data.success) {
      setRequestedLabs(response.data.results);
    }

  } catch (err) {
    console.error("Failed to load requested labs:", err);
  }finally {
    setLoading(false);
  }
};


const handleDeleteRequest = async (lab) => {
  // ✅ Confirm deletion first
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Lab Request?",
    text: `Are you sure you want to delete "${lab.lab}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });
 
  if (!confirmDelete.isConfirmed) {
    setLoading(false)
    return; 
  }

  try {
    const response = await axios.post(deleteRequestedLabdb, {
      patientId: selectedPatient.id,
      labName: lab.lab,
      dat:selectedPatient.visitDate,
      currentUser
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadRequestedLabs();

  } catch (error) {
    Swal.fire("Error", "Failed to delete lab request", "error");
  }finally {
    setLoading(false);
  }
};

const loadExistingLabResults = async (lab, category) => {
  try {
    const labDate = lab.date || new Date().toISOString().split('T')[0];

    const response = await axios.get(loadLabResults, {
      params: {
        patientId: selectedPatient.id,
        testCategory: category,
        date: labDate,
        labNo: lab.lab_no || ''
      }
    });

    if (response.data.success) {
      setEnteredResults(response.data.results || []);
      setGeneralComment(response.data.generalComment || '');
    }
  } catch (error) {
    console.error('Error loading existing results:', error);
    setEnteredResults([]);
    setGeneralComment('');
  }
};

const handleEnterLabResults = async (lab) => {
  setSelectedLabForResults(lab);
  setLabResultsDialogOpen(true);
  setSelectedParameter(null);
  setParameterResult('');
  setParameterFlag('Select/Enter');
  setEnteredResults([]);
  setAvailableFlags(['Select/Enter']);
  setGeneralComment('');
  setEditingResultIndex(null);

  const category = await loadTestParametersForLab(lab.lab);
  await loadExistingLabResults(lab, category);
};


const handleParameterSelectForLab = async (parameter) => {
  setLoadingParameterDetails(true);
  try {
    const response = await axios.get(loadParameterDetails, {
      params: {
        testName: selectedLabForResults.lab,
        parameterName: parameter.test
      }
    });

    if (response.data.success) {
      const { parameter: paramDetails, flags = [] } = response.data;
      setSelectedParameter(paramDetails);
      setAvailableFlags(['Select/Enter', ...flags]);
      setParameterResult('');
      setParameterFlag('Select/Enter');
    }
  } catch (error) {
    console.error('Error loading parameter details:', error);
    setSelectedParameter(null);
    setAvailableFlags(['Select/Enter']);
  } finally {
    setLoadingParameterDetails(false);
  }
};

const getLabParameterRange = (parameter) => {
  const patientGender = selectedPatient?.gender?.toUpperCase();
  if (patientGender === 'MALE' && parameter.male) return parameter.male;
  if (patientGender === 'FEMALE' && parameter.female) return parameter.female;
  if (parameter.children) return parameter.children;
  return 'Not specified';
};

const detectLabFlag = (result, range) => {
  if (!result || !result.trim() || range === 'Not specified') return 'normal';
  const rangeMatch = range.match(/(\d*\.?\d+)\s*-\s*(\d*\.?\d+)/);
  if (!rangeMatch) return 'normal';

  const minVal = parseFloat(rangeMatch[1]);
  const maxVal = parseFloat(rangeMatch[2]);
  const resultVal = parseFloat(result.trim());

  if (isNaN(resultVal) || isNaN(minVal) || isNaN(maxVal)) return 'normal';
  if (resultVal < minVal) return 'low';
  if (resultVal > maxVal) return 'high';
  return 'normal';
};

const handleLabResultChange = (value) => {
  setParameterResult(value);
  if (selectedParameter) {
    const range = getLabParameterRange(selectedParameter);
    if (range !== 'Not specified') {
      setParameterFlag(detectLabFlag(value, range));
    }
  }
};

const handleLabFlagChange = (value) => {
  setParameterFlag(value);
  if (selectedParameter) {
    const range = getLabParameterRange(selectedParameter);
    if (range === 'Not specified') {
      setParameterResult(value);
    }
  }
};

const handleAddLabResult = () => {
  if (!selectedParameter || !parameterResult.trim()) {
    Swal.fire({ icon: 'warning', title: 'Missing Info', text: 'Select a parameter and enter a result.' });
    return;
  }

  const newResult = {
    parameterName: selectedParameter.test,
    result: parameterResult,
    unit: selectedParameter.unit || '',
    range: getLabParameterRange(selectedParameter),
    flag: parameterFlag
  };

  if (editingResultIndex !== null) {
    const existing = enteredResults[editingResultIndex];
    if (existing.trans_code) newResult.trans_code = existing.trans_code;
    const updated = [...enteredResults];
    updated[editingResultIndex] = newResult;
    setEnteredResults(updated);
    setEditingResultIndex(null);
  } else {
    const isDuplicate = enteredResults.some(r => r.parameterName === selectedParameter.test);
    if (isDuplicate) {
      Swal.fire({ icon: 'warning', title: 'Duplicate', text: 'Parameter already added. Use edit to modify.' });
      return;
    }
    setEnteredResults([...enteredResults, newResult]);
  }

  setSelectedParameter(null);
  setParameterResult('');
  setParameterFlag('Select/Enter');
  setAvailableFlags(['Select/Enter']);
};

const handleEditLabResult = (index) => {
  const result = enteredResults[index];
  setEditingResultIndex(index);
  const param = testParameters.find(p => p.test === result.parameterName);
  if (param) {
    setSelectedParameter(param);
    setParameterResult(result.result);
    setParameterFlag(result.flag);
    handleParameterSelectForLab(param);
  }
};

const handleCancelLabEdit = () => {
  setEditingResultIndex(null);
  setSelectedParameter(null);
  setParameterResult('');
  setParameterFlag('Select/Enter');
  setAvailableFlags(['Select/Enter']);
};

const handleRemoveLabResult = async (resultItem) => {
  if (!resultItem.trans_code) {
    setEnteredResults(enteredResults.filter(r => r !== resultItem));
    return;
  }

  const confirm = await Swal.fire({
    title: 'Remove Result?',
    text: 'This will permanently delete this result.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, Remove',
    confirmButtonColor: '#d33'
  });

  if (!confirm.isConfirmed) return;

  try {
    const response = await axios.delete(deleteResultC(resultItem.trans_code));
    if (response.data.success) {
      setEnteredResults(enteredResults.filter(r => r.trans_code !== resultItem.trans_code));
      Swal.fire({ icon: 'success', title: 'Removed', timer: 1500, showConfirmButton: false });
    }
  } catch (error) {
    Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to remove result.' });
  }
};

const handleSaveLabResults = async () => {
  if (enteredResults.length === 0) {
    Swal.fire({ icon: 'warning', title: 'No Results', text: 'Add at least one result before saving.' });
    return;
  }

  const confirm = await Swal.fire({
    title: 'Save Results?',
    text: `Save ${enteredResults.length} result(s) for ${selectedLabForResults.lab}?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Save'
  });

  if (!confirm.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(saveLabResults, {
      patientId: selectedPatient.id,
      testName: selectedLabForResults.lab,
      testCategory: testCategory,
      lab_no: selectedLabForResults.lab_no || '',
      results: enteredResults,
      enteredBy: currentUser,
      enteredDate: selectedLabForResults.date || new Date().toISOString().split('T')[0],
      generalComment: generalComment,
      patientInfo: {
        name: selectedPatient.fullName,
        age: selectedPatient.age,
        gender: selectedPatient.gender,
        path_no: selectedPatient.id
      }
    });

    if (response.data.success) {
      Swal.fire({ icon: 'success', title: 'Saved!', text: `${enteredResults.length} result(s) saved.`, timer: 2000, showConfirmButton: false });
      setLabResultsDialogOpen(false);
      loadRequestedLabs(); // refresh
    }
  } catch (error) {
    Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to save results.' });
  } finally {
    setLoading(false);
  }
};


const loadTestParametersForLab = async (testName) => {
  setLoadingParameters(true);
  try {
    const response = await axios.get(loadLabTestParameters, {
      params: { name: testName }
    });

    if (response.data.success) {
      setTestParameters(response.data.parameters);
      setTestCategory(response.data.category);
      return response.data.category;
    }
  } catch (error) {
    console.error('Error loading test parameters:', error);
    setTestParameters([]);
    setTestCategory('');
    return '';
  } finally {
    setLoadingParameters(false);
  }
};


// Available Labs pagination
const [labPage, setLabPage] = useState(0);
const [labRowsPerPage, setLabRowsPerPage] = useState(8);

// Requested Labs pagination
const [reqPage, setReqPage] = useState(0);
const [reqRowsPerPage, setReqRowsPerPage] = useState(8);


//Scan

// Available scans

const [scans, setscans] = useState([]);


const loadAvailableScans = async () => {
  if (!selectedPatient || !selectedPatient.insurance) return;

  setLoading(true);
  try {
    const response = await axios.get(loadAvailableScansdb, {
      params: {
        insurance: selectedPatient.insurance,
      },
    });

    if (response.data.success) {
      setscans(response.data.results);
    }

  } catch (error) {
    console.error("Error loading scans:", error);
  }finally {
    setLoading(false);
  }
};


const loadRequestedScan = async () => {
  if (!selectedPatient || !selectedPatient.id) return;
 setLoading(true);
  try {
    const response = await axios.get(loadRequestedScandb, {
      params: {
        patientId: selectedPatient.id,
        dat:selectedPatient.visitDate,
      },
    });

    if (response.data.success) {
      setRequestedScans(response.data.results);
    }

  } catch (err) {
    console.error("Failed to load requested labs:", err);
  }finally {
    setLoading(false);
  }
};


// Scan Search
const [scanSearchTerm, setScanSearchTerm] = useState("");

// Requested Scans
const [requestedScans, setRequestedScans] = useState([]);

// Pagination for scans
const [scanPage, setScanPage] = useState(0);
const [scanRowsPerPage, setScanRowsPerPage] = useState(8);
const [reqScanPage, setReqScanPage] = useState(0);
const [reqScanRowsPerPage, setReqScanRowsPerPage] = useState(8);

// Request Scan

const handleRequestScan = async (scan) => {

  const alreadyRequested = requestedScans.some(
    (r) => (r.lab || r.scan) === (scan.name || scan.lab)
  );
  if (alreadyRequested) {
    ErrorMessage(
      "Already Requested",
      `${scan.name} has already been requested today.`
    );
    return;
  }
setLoading(true);
  try {
    const response = await axios.post(requestLab, {
      patientId: selectedPatient.id,
      patientInsurance: selectedPatient.insurance,
      labName: scan.name,
      amount: scan.amount,
      base_cost: scan.tariff,
      code: scan.code,
      currentUser ,
      type:'Scan',
      dat:selectedPatient.visitDate,
    });

    if (response.data.success) {
      loadRequestedScan();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request Scan");
  }finally {
    setLoading(false);
  }

 
};

// Delete Scan Request
const handleDeleteScanRequest = async(scan) => {
  setLoading(true);
  //console.log(scan)
  const confirmDelete = await Swal.fire({
    title: "Delete Scan Request?",
    text: `Are you sure you want to delete "${scan.lab}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
    
     setLoading(false)
    return; // ✅ User cancelled → STOP
  }

  try {
    const response = await axios.post(deleteRequestedLabdb, {
      patientId: selectedPatient.id,
      labName: scan.lab,
      currentUser ,
      dat:selectedPatient.visitDate,
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadRequestedScan();

  } catch (error) {
    Swal.fire("Error", "Failed to delete lab request", "error");
  }finally {
    setLoading(false);
  }
};


const handleEnterScanResults = async (scan) => {
  // scan object from requestedScans has: lab (scan name), date, amount, status, etc.
  setSelectedScanForResults(scan);
  setScanResultsDialogOpen(true);
  setSelectedScanParameter(null);
  setScanParameterResult('');
  setScanParameterFlag('-');
  setEnteredScanResults([]);
  setAvailableScanFlags(['-']);
  setScanGeneralComment('');
  setEditingScanResultIndex(null);

  // Load parameters for this scan
  await loadScanParametersForOutpatient(scan.lab); // scan.lab holds scan name in requestedScans

  // Load existing results
  await loadExistingScanResultsForOutpatient(scan);
};

const loadScanParametersForOutpatient = async (scanName) => {
  setLoadingScanParameters(true);
  try {
    const response = await fetch(loadScanParametersAPI(scanName));
    const data = await response.json();

    if (data.success && data.parameters) {
      const transformed = data.parameters.map((param) => ({
        id: param.id,
        name: param.paramater,
        flags: param.Flag && param.Flag.trim() !== '' 
          ? param.Flag.split(',').map(f => f.trim()) 
          : []
      }));
      setScanTestParameters(transformed);
    } else {
      setScanTestParameters([]);
    }
  } catch (error) {
    console.error('Error loading scan parameters:', error);
    setScanTestParameters([]);
  } finally {
    setLoadingScanParameters(false);
  }
};

const loadExistingScanResultsForOutpatient = async (scan) => {
  try {
    const currentDate = scan.date || new Date().toISOString().split('T')[0];

    const response = await fetch(loadExistingScanResults, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        patientId: selectedPatient.id,
        scanName: scan.lab,
        date: currentDate
      })
    });

    const data = await response.json();

    if (data.success && data.results && data.results.length > 0) {
      const transformed = data.results.map(r => ({
        parameterId: r.id,
        parameterName: r.para,
        result: r.finding,
        flag: r.flag || '-'
      }));
      setEnteredScanResults(transformed);
    } else {
      setEnteredScanResults([]);
    }
  } catch (error) {
    console.error('Error loading existing scan results:', error);
    setEnteredScanResults([]);
  }
};

const handleScanParameterSelect = (parameter) => {
  setSelectedScanParameter(parameter);
  setScanParameterResult('');
  const defaultFlag = parameter.flags && parameter.flags.length > 0 
    ? parameter.flags[0].toLowerCase() 
    : '-';
  setScanParameterFlag(defaultFlag);
  setAvailableScanFlags(parameter.flags && parameter.flags.length > 0 ? parameter.flags : ['-']);
};

const handleAddScanResult = () => {
  if (!selectedScanParameter || !scanParameterResult.trim()) {
    Swal.fire({ icon: 'warning', title: 'Missing Info', text: 'Select a parameter and enter a result.' });
    return;
  }

  const newResult = {
    parameterId: selectedScanParameter.id,
    parameterName: selectedScanParameter.name,
    result: scanParameterResult,
    flag: scanParameterFlag
  };

  if (editingScanResultIndex !== null) {
    const updated = [...enteredScanResults];
    updated[editingScanResultIndex] = newResult;
    setEnteredScanResults(updated);
    setEditingScanResultIndex(null);
  } else {
    // Check duplicate
    const isDup = enteredScanResults.some(r => r.parameterName === selectedScanParameter.name);
    if (isDup) {
      Swal.fire({ icon: 'warning', title: 'Duplicate', text: 'Parameter already added. Use edit to modify.' });
      return;
    }
    setEnteredScanResults([...enteredScanResults, newResult]);
  }

  setSelectedScanParameter(null);
  setScanParameterResult('');
  setScanParameterFlag('-');
  setAvailableScanFlags(['-']);
};

const handleEditScanResult = (index) => {
  const result = enteredScanResults[index];
  setEditingScanResultIndex(index);
  const param = scanTestParameters.find(p => p.id === result.parameterId);
  if (param) {
    setSelectedScanParameter(param);
    setScanParameterResult(result.result);
    setScanParameterFlag(result.flag);
    setAvailableScanFlags(param.flags && param.flags.length > 0 ? param.flags : ['-']);
  } else {
    setSelectedScanParameter({ id: result.parameterId, name: result.parameterName });
    setScanParameterResult(result.result);
    setScanParameterFlag(result.flag);
  }
};

const handleCancelScanEdit = () => {
  setEditingScanResultIndex(null);
  setSelectedScanParameter(null);
  setScanParameterResult('');
  setScanParameterFlag('-');
  setAvailableScanFlags(['-']);
};

const handleRemoveScanResult = (index) => {
  const updated = enteredScanResults.filter((_, i) => i !== index);
  setEnteredScanResults(updated);
  if (editingScanResultIndex === index) {
    handleCancelScanEdit();
  }
};

const handleSaveScanResults = async () => {
  if (enteredScanResults.length === 0) {
    Swal.fire({ icon: 'warning', title: 'No Results', text: 'Add at least one result before saving.' });
    return;
  }

  const confirm = await Swal.fire({
    title: 'Save Scan Results?',
    text: `Save ${enteredScanResults.length} result(s) for ${selectedScanForResults.lab}?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Save'
  });

  if (!confirm.isConfirmed) return;

  Swal.fire({
    title: 'Saving...',
    text: 'Please wait...',
    allowOutsideClick: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    const currentDate = selectedScanForResults.date || new Date().toISOString().split('T')[0];

    const response = await fetch(saveScanResults, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        patientId: selectedPatient.id,
        scanName: selectedScanForResults.lab,
        results: enteredScanResults.map(r => ({
          parameterName: r.parameterName,
          result: r.result,
          flag: r.flag
        })),
        user: currentUser,
        date: currentDate
      })
    });

    const data = await response.json();

    if (data.success) {
      Swal.fire({ icon: 'success', title: 'Saved!', text: `${enteredScanResults.length} result(s) saved.`, timer: 2000, showConfirmButton: false });
      setScanResultsDialogOpen(false);
      loadRequestedScan(); // refresh requested scans table
    } else {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to save scan results.' });
    }
  } catch (error) {
    console.error('Error saving scan results:', error);
    Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while saving.' });
  }
};


// 1️⃣ helper function FIRST
const getPatientType = (patient) => {
  const visit = patient.visitDate || patient.dat;
  const discharge = patient.d_dat;

  if (!discharge) return "inpatient";
  if (visit === discharge) return "outpatient";
  return "inpatient";
};


// 2️⃣ search filter
const filteredPatientList = allPatients.filter((p) => {
  if (!patientSearchTerm) return true;

  const term = patientSearchTerm.toLowerCase();
  const name = (p.fullName || "").toLowerCase();
  const id = (p.id || "").toLowerCase();
  const tel = (p.tel || "").toLowerCase();

  return name.includes(term) || id.includes(term) || tel.includes(term);
});

// 3️⃣ state filter
const filteredByState = filteredPatientList.filter((p) => {
  if (stateFilter === "all") return true;
  return getPatientType(p) === stateFilter;
});


// 4️⃣ service type filter
const filteredByService = filteredByState.filter((p) => {
  if (!serviceTypeFilter) return true;
  return (p.service_type || '') === serviceTypeFilter;
});

// 5️⃣ pagination
const paginatedPatientList = filteredByService.slice(
  patientPage * patientRowsPerPage,
  patientPage * patientRowsPerPage + patientRowsPerPage
);

// ── ADD THIS LINE right here ──
const isCurrentPatientOPD = selectedPatient
  ? getPatientType(selectedPatient) === "outpatient"
  : false;



// Medication States
const [medications, setMedications] = useState([]);


const isMedicationChronic = (drugName) => {
  if (!chronicMeds || chronicMeds.length === 0) return false;
  
  // ✅ Normalize the drug name
  const normalizedDrugName = drugName.toLowerCase().trim().replace(/\s+/g, ' ');
  
  return chronicMeds.some(cm => {
    if (!cm || !cm.medication) return false;
    
    const normalizedChronicName = cm.medication.toLowerCase().trim().replace(/\s+/g, ' ');
    
    // ✅ Try exact match first
    if (normalizedChronicName === normalizedDrugName) {
      return true;
    }
    
    // ✅ Try partial match (contains)
    return normalizedDrugName.includes(normalizedChronicName) || 
           normalizedChronicName.includes(normalizedDrugName);
  });
};

// Update loadMedications to accept chronic meds as parameter
const loadMedications = async (chronicMedsData = null) => {
  if (!selectedPatient) return;

  setLoading(true);
  try {
    const response = await axios.get(loadMedicationsdb, {
      params: { insurance: selectedPatient.insurance }
    });

    if (response.data.success) {
      let meds = response.data.results;

      // ✅ Use passed parameter OR state
      const chronicMedsToUse = chronicMedsData || chronicMeds;

      console.log("📦 Total medications loaded:", meds.length);
      console.log("💊 Chronic meds to use:", chronicMedsToUse);

      // ✅ Sort chronic medications to top
      if (chronicMedsToUse && chronicMedsToUse.length > 0) {
        console.log("🔄 Sorting chronic meds to top...");
        
        const chronicNames = chronicMedsToUse
          .filter(m => m && m.medication)
          .map(m => m.medication.toLowerCase().trim().replace(/\s+/g, ' '));
        
        console.log("Chronic drug names:", chronicNames);

        meds = meds.sort((a, b) => {
          const aName = a && a.name 
            ? a.name.toLowerCase().trim().replace(/\s+/g, ' ')
            : '';
          const bName = b && b.name 
            ? b.name.toLowerCase().trim().replace(/\s+/g, ' ')
            : '';
          
          let aIsChronic = chronicNames.includes(aName);
          let bIsChronic = chronicNames.includes(bName);
          
          if (!aIsChronic) {
            aIsChronic = chronicNames.some(cn => aName.includes(cn) || cn.includes(aName));
          }
          if (!bIsChronic) {
            bIsChronic = chronicNames.some(cn => bName.includes(cn) || cn.includes(bName));
          }
          
          return bIsChronic - aIsChronic;
        });

        console.log("✅ First 5 sorted meds:", meds.slice(0, 5).map(m => m.name));
      }

      setMedications(meds);
    }

  } catch (error) {
    console.error("Failed to load medications:", error);
  } finally {
    setLoading(false);
  }
};


// 3. ✅ NEW FUNCTION - Handle medication selection with chronic auto-fill
const handleSelectMedication = (med) => {
  setSelectedMed(med);
  
  // ✅ Check if this medication exists in chronic meds with flexible matching
  const chronicMed = chronicMeds && chronicMeds.length > 0 
    ? chronicMeds.find(cm => {
        if (!cm || !cm.medication || !med || !med.name) return false;
        
        const normalizedChronicName = cm.medication.toLowerCase().trim().replace(/\s+/g, ' ');
        const normalizedMedName = med.name.toLowerCase().trim().replace(/\s+/g, ' ');
        
        // Try exact match first
        if (normalizedChronicName === normalizedMedName) {
          return true;
        }
        
        // Try partial match
        return normalizedMedName.includes(normalizedChronicName) || 
               normalizedChronicName.includes(normalizedMedName);
      })
    : null;

  if (chronicMed) {
    // ✅ Auto-fill with chronic medication details
    console.log("✅ Chronic medication found:", chronicMed);
    
    const doseString = chronicMed.dose || "";
    const doseParts = doseString.split(" ");
    setDoseAmount(doseParts[0] || "");
    setDoseUnit(doseParts[1] || "");
    
    setFrequency(chronicMed.freq || "");
    setDays(chronicMed.days || "");
    setQty(chronicMed.qty || 0);
    setRoute(chronicMed.route || "");
    setAutoCalculate(true);
  } else {
    // ✅ Regular flow
    const { medStrength } = extractStrengthFromName(med.name);
    setDoseUnit(medStrength || "");
    setAutoCalculate(isSolidByName(med.name) || isAutoCalcUnit(medStrength));
    
    if (selectedPatient && selectedPatient.age) {
      loadLastMedicationPattern(med.name, selectedPatient.age, selectedPatient.dob);
    }
  }
};


// Pagination
const [medPage, setMedPage] = useState(0);
const [medRowsPerPage, setMedRowsPerPage] = useState(10);
const [reqMedPage, setReqMedPage] = useState(0);
const [reqMedRowsPerPage, setReqMedRowsPerPage] = useState(10);
const [medError, setMedError] = useState(false);


// Add medication
const handleAddMedication = async () => {

  //console.log(requestedMeds)
  // ------------------------------------
  // ✅ VALIDATION
  // ------------------------------------
  let hasError = false;

  if (!selectedMed) {
    ErrorMessage("Error", "Please select a medication first");
    return;
  }

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }

  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }

  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }

  if (!route) {
    setRouteError(true);
    hasError = true;
  }

  // qty validation depending on autoCalculate
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }

  if (hasError) return;

  // ------------------------------------
  // ✅ DUPLICATE-PREVENTION
  // ------------------------------------

  // Backend returns date format: YYYY-MM-DD
  const today = new Date().toISOString().split("T")[0];

  const alreadyRequested = requestedMeds.some(
    (r) =>
      r.drug == selectedMed.name              // ✅ exact match with backend date
  );

  if (alreadyRequested) {
    ErrorMessage(
      "Error",
      `${selectedMed.name} has already been requested today.`
    );
    return;
  }

  setLoading(true);
  try {
    const response = await axios.post(addMedicationdb, {
      patientId: selectedPatient.id,
      selectedMed,
      qty,
      frequency,
      route,
      doseAmount,
      days,
      currentUser,
      insurance: selectedPatient.insurance,
      dat:selectedPatient.visitDate,
      age:selectedPatient.age
    });

    // ------------------------------------
    // ✅ SUCCESS HANDLING
    // ------------------------------------
    if (response.data.success) {
      //successMessage("Success", "Medication added successfully");
      loadRequestedMeds();     // reload meds table
      handleClearMedication(); // reset inputs
    }
  } catch (err) {
    ErrorMessage("Error", "Failed to save medication");
  }finally {
    setLoading(false);
  }
};


const loadRequestedMeds = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadRequestedMedsdb, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, }
    });

    if (response.data.success) {
      setRequestedMeds(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


const handleClearMedication = () => {
  setSelectedMed(null);
  setDoseAmount("");
  setDoseUnit("");
  setFrequency("");
  setDays("");
  setQty(0);
  setRoute("");
  setAutoCalculate(true);
  
  // reset errors
  setDoseAmountError(false);
  setFrequencyError(false);
  setDaysError(false);
  setRouteError(false);
  setQtyError(false);
  setMedError(false);

  // ✅ reset editing mode so button goes back to "Make Request"
  setEditingIndex(null);
};

 
// Delete medication
const handleDeleteMedication = async (med) => {
  //console.log(med);

  // 1️⃣ Confirm delete
  setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Medication?",
    text: `Are you sure you want to delete "${med.drug || "this medication"}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
     setLoading(false)
     return
  }  // user cancelled
  try {
    // 2️⃣ Send delete request (POST)
    const response = await axios.post(medicationdeletedb, {
      trans_code: med.trans_code,
      patientId: selectedPatient.id,
      insurance: selectedPatient.insurance,
      dat:selectedPatient.visitDate,
    });

    // 3️⃣ If backend says reversal required
    if (response.data.reversalRequired) {
      Swal.fire(
        "REVERSAL REQUIRED",
        response.data.message ||
          "This medication has already been paid for. Refund/reversal is required.",
        "warning"
      );
      return;
    }

    // 4️⃣ Successful deletion
    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadRequestedMeds(); // refresh table
      return;
    }

    // 5️⃣ Backend returned an error
    Swal.fire(
      "Error",
      response.data.message || "Could not delete medication.",
      "error"
    );

  } catch (error) {
    console.error("DELETE MEDICATION ERROR:", error);
    Swal.fire("Error", "Something went wrong.", "error");
  }finally {
    setLoading(false);
  }
};


// Edit medication
const [editingIndex, setEditingIndex] = useState(null);
const [EditMad , setEditMad] =useState()

const handleEditMedication = (idx) => {
  const med = requestedMeds[idx];

  setEditMad(med)
  setSelectedMed({ name: med.drug });
  setDoseAmount(med.dose.split(" ")[0]);
  setDoseUnit(med.dose.split(" ")[1] || "");
  setFrequency(med.freq);
  setDays(med.days);
  setQty(med.qty);
  setRoute(med.route);
  setAutoCalculate(true);
  setEditingIndex(idx); // mark edit mode
};


const handleUpdateMedication = async () => {
  if (!EditMad || !EditMad.trans_code) {
    ErrorMessage("Error", "No medication selected for update.");
    return;
  }

  let hasError = false;

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }
  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }
  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }
  if (!route) {
    setRouteError(true);
    hasError = true;
  }
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }

  if (hasError) return;

  setLoading(false);
  try {
    const response = await axios.post(updateMedicationdb, {
      trans_code: EditMad.trans_code, // ✅ identify the record
      doseAmount,
      frequency,
      days,
      route,
      qty,
      currentUser,
      patientId: selectedPatient.id,
      insurance: selectedPatient.insurance,
      dat:selectedPatient.visitDate,
    });

    if (response.data.success) {
      successMessage("Success", "Medication updated successfully");
      loadRequestedMeds();  // reload data
      handleClearMedication();
    } else {
      ErrorMessage("Error", response.data.message || "Failed to update medication");
    }
  } catch (error) {
    ErrorMessage("Error", "Unable to update medication");
    console.error("Update medication error:", error);
  }finally {
    setLoading(false);
  }
};


const loadMedicationStock = async (medicationName) => {
  try {
    const response = await axios.get(medicationStock, {
      params: { name: medicationName }
    });
    
    if (response.data.success) {
      return response.data.stock;
    }
    return null;
  } catch (error) {
    console.error("Error loading medication stock:", error);
    return null;
  }
};

const handleMedicationInfo = async (med) => {
  setMedInfoLoading(true); // ✅ Start loading
  setSelectedMedInfo(med); // ✅ Set basic info immediately
  setMedInfoDialogOpen(true); // ✅ Open dialog
  
  try {
    const stockInfo = await loadMedicationStock(med.name);
    setSelectedMedInfo({ ...med, ...stockInfo }); // ✅ Update with stock info
  } catch (error) {
    console.error("Error loading stock:", error);
    ErrorMessage("Error", "Failed to load stock information");
  } finally {
    setMedInfoLoading(false); // ✅ Stop loading
  }
};


const [medDialogOpen, setMedDialogOpen] = useState(false);

// Helper function
const normalizeFrequency = (freq) => {
  if (!freq) return "";
  return frequencyMap[freq.toLowerCase().trim()] || freq;
};


const autoCalcUnits = [
  "tab", "tablet",
  "cap", "capsule",
  "pill", "lozenge", "suppository",
  "amp", "vial"
];

const isAutoCalcUnit = (unit = "") => {
  return autoCalcUnits.some(u => unit.toLowerCase().includes(u));
};

const solidKeywords = ["tablet", "tab", "capsule", "cap", "pill", "lozenge", "suppository"];
const isSolidByName = (name = "") => {
  return solidKeywords.some(k => name.toLowerCase().includes(k));
};


// Unicode fraction mapping
const FRACTION_MAP = { "¼": 0.25, "½": 0.5, "¾": 0.75 };
const normalizeUnicodeFractions = (s) =>
  String(s || "").replace(/[¼½¾]/g, (m) => String(FRACTION_MAP[m] ?? m));

/** Extract numeric part from a dose string like "500ml", "1/2 tab", "½ cap", "5 mg" */
const parseDoseNumber = (doseStr) => {
  if (!doseStr) return 0;
  const cleaned = normalizeUnicodeFractions(doseStr).trim().toLowerCase();
  // match number (int/decimal or fraction) at the start
  const m = cleaned.match(/^(\d+(?:\.\d+)?|\d+\/\d+)/);
  if (!m) return 0;
  if (m[1].includes("/")) {
    const [a, b] = m[1].split("/").map(Number);
    return b ? a / b : Number(m[1]) || 0;
  }
  return parseFloat(m[1]) || 0;
};

/** Compute quantity from either split doseAmount or free-text dose */
const computeQty = ({
  doseAmount,
  doseString,
  days,
  frequency,
  doseUnit,
  normalizeFrequencyFn,
  freqMultiplierMap
}) => {
  const normalized = normalizeFrequencyFn(frequency || "");
  const perDay = freqMultiplierMap[normalized] ?? 1;

  const amount =
    typeof doseAmount === "number" && !isNaN(doseAmount)
      ? doseAmount
      : parseDoseNumber(doseString);

  if (!amount || !Number(days)) return 0;

  // ✅ Same formula for liquids and solids
  // Quantity = dose × frequency per day × number of days
  return Math.ceil(Number(amount) * Number(perDay) * Number(days));
};


const loadLastMedicationPattern = async (selectedMedName, patientAge, patientDob) => {
  try {
    // Prefer DOB so an 11y11m child can't be tipped into the adult bucket by
    // an integer-rounded `patientAge`. Falls back to the numeric age when no
    // DOB is on the patient record.
    const ageGroup = isAdultFromDobOrAge(patientDob, patientAge) ? "adult" : "child";

    const res = await axios.get(loadMedicationByAge, {
      params: { name: selectedMedName, age:ageGroup }
    });

    if (res.data.success) {
      const p = res.data.med;

      // 🔥 Auto-fill only if backend found data
      setDoseAmount(p.dose);
      setFrequency(p.freq);
      setDays(p.day_server);
      setRoute(p.rou);
      setQty(p.qua);


    }else {
      setDoseAmount('');
      setFrequency('');
      setDays('');
      setRoute('');
      setQty('');
    }
  } catch (error) {
    console.log("Error loading medication pattern:", error);
  }
};


const extractStrengthFromName = (name) => {
  if (!name) return { medName: "", medStrength: "" };

  loadLastMedicationPattern(name, selectedPatient.age, selectedPatient.dob);

  let medName = name.trim();
  let medStrength = "";

  // Case 1: If there is a comma, assume strength is after the last comma
  if (name.includes(",")) {
    const parts = name.split(",");
    medName = parts.slice(0, -1).join(",").trim();
    medStrength = parts[parts.length - 1].trim();
  } else {
    // Case 2: If it ends with (...) → treat last parentheses as strength
    const parenMatch = name.match(/^(.*)\(([^()]*)\)\s*$/);
    if (parenMatch) {
      medName = parenMatch[1].trim();
      medStrength = parenMatch[2].trim();
    } else {
      // Case 3: Try to match trailing numeric + unit like "80mg/mL", "0.5%", "125mls"
      const match = name.match(/(.*?)(\d+(?:\.\d+)?\s?(?:mg\/ml|mg|g|mcg|ml|mls|%|units?|iu))$/i);
      if (match) {
        medName = match[1].trim();
        medStrength = match[2].trim();
      }
    }
  }

  return { medName, medStrength };

  
};


const [doseAmountError, setDoseAmountError] = useState(false);
const [frequencyError, setFrequencyError] = useState(false);
const [daysError, setDaysError] = useState(false);
const [routeError, setRouteError] = useState(false);
const [qtyError, setQtyError] = useState(false);


const handleChronicRefill = async (med) => {
  Swal.fire({
    title: "Chronic Medication Refill?",
    text: `Refill ${med.drug} for this patient?`,
    showCancelButton: true,
    confirmButtonText: "Yes, Refill",
    cancelButtonText: "Cancel",
    icon: "info"
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    try {
      // Save or update chronic medication
      const response =await axios.post(saveChronicMedication, {
        patientId: selectedPatient.id,
        drug: med.drug,
        dose: med.dose,
        freq: med.freq,
        days: med.days,
        qty: med.qty,
        route: med.route,
        doctor: currentUser
      });


      if (response.data.success) {
      successMessage("Success", "Chronic medication saved successfully");
    } else {
      ErrorMessage("Error", response.data.message || "Failed to Save Chronic medication");
    }
    } catch (error) {
      Swal.fire("Error", "Failed to save chronic medication", "error");
      return;
    }

  });
};


//Other Services

const [services, setservices] = useState([]);
const [serviceQuantities, setServiceQuantities] = useState({});

const loadOtherServices = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadOtherServicesdb, {
      params: {
        charge_status: "Manual",
      }
    });

    if (response.data.success) {
      setservices(response.data.results);
    } else {
      setservices([]);
    }

  } catch (error) {
    console.error("Failed to load other services:", error);
    setservices([]);
  }finally {
    setLoading(false);
  }
};


// Search
const [serviceSearchTerm, setServiceSearchTerm] = useState("");

// Requested Services
const [requestedServices, setRequestedServices] = useState([]);

const loadrequestedServices = async () => {
   setLoading(false);
  try {
    const response = await axios.get(loadRequestedOtherServicesdb, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, }
    });

    if (response.data.success) {
      setRequestedServices(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


// Pagination
const [servicePage, setServicePage] = useState(0);
const [serviceRowsPerPage, setServiceRowsPerPage] = useState(8);
const [reqServicePage, setReqServicePage] = useState(0);
const [reqServiceRowsPerPage, setReqServiceRowsPerPage] = useState(8);


// Request a service (prevents duplicate request on the same day)
const handleRequestService = async(srv) => {

  const existsToday = requestedServices.some(
    (r) => r.service === srv.name) 
  if (existsToday) {
    ErrorMessage('"Already Requested",' ,`${srv.name} has already been requested today.`);
    return;
  }

   setLoading(true);
    try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat:selectedPatient.visitDate,
      charge: srv.name,
      amount: srv.amount,
      doc_name:currentUser,
      from_user:currentUser,
      name:selectedPatient.fullName,
      department:'Doctor'
    });

    if (response.data.success) {
      loadrequestedServices();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request Non Insured Services ");
  }finally {
    setLoading(false);
  }

 // setRequestedServices((prev) => [...prev, newReq]);
}; 



// Delete a requested service (allowed only if Pending in UI)
const handleDeleteServiceRequest = async (req) => {
  // ✅ Confirm deletion first
 
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Other Request?",
    text: `Are you sure you want to delete "${req.service}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
    setLoading(false)
    return; 
  }

   try {
    const response = await axios.post(deleteOrReverseOtherServicedb, {
      patientId: selectedPatient.id,
      scanName: req.service,
      dat:selectedPatient.visitDate,
      currentUser
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadrequestedServices();

  } catch (error) {
    Swal.fire("Error", "Failed to delete Other request", "error");
  }finally {
    setLoading(false);
  }
};


const handleManualServiceRequest = async () => {
  if (!manualServiceName || !manualAmount) {
    ErrorMessage("Missing info", "Enter service name and amount");
    return;
  }

  // prevent duplicate same-day request
  const existsToday = requestedServices.some(
    r => r.service.toLowerCase() === manualServiceName.toLowerCase()
  );

  if (existsToday) {
    ErrorMessage("Already Requested", "Service already requested today");
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      charge: manualServiceName,
      amount: Number(manualAmount) * Number(manualQty),
      doc_name: currentUser,
      from_user: currentUser,
      name: selectedPatient.fullName,
      department: "Doctor"
    });

    if (response.data.success) {
      loadrequestedServices();

      // clear fields
      setManualServiceName("");
      setManualQty(1);
      setManualAmount("");
    }
  } catch (err) {
    ErrorMessage("Error", "Failed to request service");
  } finally {
    setLoading(false);
  }
};


// Appointment

const [editingAppointmentId, setEditingAppointmentId] = useState(null);

// Load appointments
const [appointments, setAppointments] = useState([]);

const loadAppointments = async () => {
  try {
     setLoading(true);
    const response = await axios.get(loadAppointmentsdb, {
      params: { 
        patientId: selectedPatient?.id,
        doctorName: currentUser 
      }
    });

    if (response.data.success) {
      console.log(response.data.appointments)
      setAppointments(response.data.appointments || []);
    }
  } catch (error) {
    console.error("Error loading appointments:", error);
    ErrorMessage("Error", "Failed to load appointments");
  }finally {
    setLoading(false);
  }
};


// ✅ ADD THIS FUNCTION in OutPatient.jsx
const scheduleAppointmentSMS = async (appointmentDate, appointmentTime, appointmentType) => {
  try {
    const response = await axios.post(scheduleAppointmentSms, {
      tel: selectedPatient.tel,
      patientName: selectedPatient.fullName,
      appointmentDate,
      appointmentTime,
      appointmentType
    });

    if (response.data.success) {
      console.log('✅ SMS scheduled:', response.data.message);
    } else {
      console.warn('⚠️ SMS scheduling failed:', response.data.message);
    }
  } catch (error) {
    console.error('❌ Failed to schedule SMS:', error);
  }
};


// Save appointment
const handleSaveAppointment = async () => {
  if (!selectedPatient || !appointmentDate || !appointmentTime || !appointmentType) {
    ErrorMessage("Error", "Please complete all required fields.");
    return;
  }

  setLoading(true);
  try {
    if (editingAppointmentId) {
      const response = await axios.post(updateAppointmentdb, {
        appointmentId: editingAppointmentId,
        appointmentDate,
        appointmentTime,
        appointmentType,
        reason: appointmentReason,
        otherInfo: appointmentOther,
        sendReminder
      });

      if (response.data.success) {
        successMessage("Success", "Appointment updated successfully");
        loadAppointments();
        handleClearAppointmentForm();

        // ✅ Schedule SMS on update if reminder checked
        if (sendReminder) {
          await scheduleAppointmentSMS(appointmentDate, appointmentTime, appointmentType);
          Swal.fire({
            icon: 'success',
            title: 'Reminder Scheduled',
            text: `SMS reminder scheduled for ${selectedPatient.fullName} on ${appointmentDate} at ${appointmentTime}`,
            timer: 3000,
            showConfirmButton: false
          });
        }
      } else {
        ErrorMessage("Error", response.data.message);
      }

    } else {
      const response = await axios.post(saveAppointmentdb, {
        patientId: selectedPatient.id,
        patientName: selectedPatient.fullName,
        patientTel: selectedPatient.tel,
        appointmentDate,
        appointmentTime,
        appointmentType,
        reason: appointmentReason,
        otherInfo: appointmentOther,
        sendReminder,
        currentUser
      });

      if (response.data.success) {
        successMessage("Success", "Appointment saved successfully");
        loadAppointments();

        // ✅ Schedule SMS on new save if reminder checked
        if (sendReminder) {
          await scheduleAppointmentSMS(appointmentDate, appointmentTime, appointmentType);
          Swal.fire({
            icon: 'success',
            title: 'Reminder Scheduled',
            text: `SMS reminder scheduled for ${selectedPatient.fullName} on ${appointmentDate} at ${appointmentTime}`,
            timer: 3000,
            showConfirmButton: false
          });
        }
      } else {
        ErrorMessage("Error", response.data.message);
      }
    }
  } catch (error) {
    console.error("Error saving appointment:", error);
    ErrorMessage("Error", "Failed to save appointment");
  } finally {
    setLoading(false);
  }
};

// Clear form
const handleClearAppointmentForm = () => {
  setAppointmentDate("");
  setAppointmentTime("");
  setAppointmentType("");
  setAppointmentReason("");
  setAppointmentOther("");
  setSendReminder(false);
  setEditingAppointmentId(null);
};



// Delete appointment
const handleDeleteAppointment = async (editingAppointmentId) => {
  
  if (!editingAppointmentId) return;

  const confirmDelete = await Swal.fire({
    title: "Delete Appointment?",
    text: `Are you sure you want to delete this appointment for ${editingAppointmentId}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) return;

   setLoading(true);
  try {
    const response = await axios.post(deleteAppointmentdb, {
      appointmentId: editingAppointmentId
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadAppointments();
      handleClearAppointmentForm()
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting appointment:", error);
    ErrorMessage("Error", "Failed to delete appointment");
  }finally {
    setLoading(false);
  }
};


const loadPatientAppointments = async () => {
  setLoading(true);
  try {
    const res = await axios.get(getPatientAppointmentdb, {
      params: { patientId: selectedPatient.id }
    });

    if (res.data.success) {
      const allAppointments = res.data.appointments || [];

      // Update list stored in state
      setAppointments(allAppointments);

      // If no upcoming appointment → reset form
      if (allAppointments.length === 0) {
        setAppointmentDate("");
        setAppointmentTime("");
        setAppointmentType("");
        setAppointmentReason("");
        setAppointmentOther("");
        setSendReminder(false);
        setEditingAppointmentId(null);
        return;
      }

      // Get the nearest appointment
      const nextAppointment = allAppointments[0];

      setAppointmentDate(nextAppointment.date);
      setAppointmentTime(nextAppointment.time);
      setAppointmentType(nextAppointment.type);
      setAppointmentReason(nextAppointment.reason || "");
      setAppointmentOther(nextAppointment.other_info || "");
      setSendReminder(nextAppointment.send_reminder === 1);
      setEditingAppointmentId(nextAppointment.id);

      console.log("Loaded appointment:", nextAppointment);
    }
  } catch (error) {
    ErrorMessage("Error loading appointments:", error);
  }finally {
    setLoading(false);
  }
};



const [selectedDiagnoses, setSelectedDiagnoses] = useState([]);
const [selectedProcedures, setSelectedProcedures] = useState([]);
const [admissionStatus, setAdmissionStatus] = useState("");



const [appointmentDate, setAppointmentDate] = useState("");
const [appointmentTime, setAppointmentTime] = useState("");
const [appointmentType, setAppointmentType] = useState("");
const [appointmentReason, setAppointmentReason] = useState("");
const [appointmentOther, setAppointmentOther] = useState("");
const [sendReminder, setSendReminder] = useState(false);

// Unified search
const [filterSearch, setFilterSearch] = useState("");


const filteredAppointments = appointments.filter((a) => {
  const query = filterSearch.toLowerCase();
  return (
    a.patient_name.toLowerCase().includes(query) ||
    a.id.toLowerCase().includes(query) ||
    a.type.toLowerCase().includes(query) ||
    a.date.includes(query)
  );
});


//admit 

const [admissionDate, setAdmissionDate] = useState(() => new Date().toISOString().split("T")[0]);
const [admissionTime, setAdmissionTime] = useState(() => {
  const now = new Date();
  return now.toTimeString().slice(0, 5);
});
const [admissionNote, setAdmissionNote] = useState("");
const [treatmentPlan, setTreatmentPlan] = useState("");


const validateAdmissionForm = () => {
  if (!admissionStatus) {
    ErrorMessage("Missing Field", "Please select Admission Status");
    return false;
  }

  if (!admissionDate) {
    ErrorMessage("Missing Field", "Please select Date of Admission");
    return false;
  }

  if (!admissionTime) {
    ErrorMessage("Missing Field", "Please select Time of Admission");
    return false;
  }

  if (!admissionNote.trim()) {
    ErrorMessage("Missing Field", "Admission Note cannot be empty");
    return false;
  }

  if (!treatmentPlan.trim()) {
    ErrorMessage("Missing Field", "Treatment Plan cannot be empty");
    return false;
  }

  return true;
};


const submitAdmission = async () => {
  // Ask user if they want to proceed with admission
  const confirmResult = await Swal.fire({
    title: 'Confirm Admission',
    html: `
      <div style="text-align: left;">
        <p><strong>Patient:</strong> ${selectedPatient.fullName}</p>
        <p><strong>Admission Status:</strong> ${admissionStatus}</p>
        <p><strong>Date:</strong> ${moment(`${admissionDate} ${admissionTime}`).format('DD/MM/YYYY hh:mm A')}</p>
        <br/>
        <p style="font-weight: 600;">Do you want to proceed with this admission?</p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Admit Patient',
    cancelButtonText: 'No, Cancel'
  });

  // If user clicks "No" or closes dialog, do nothing
  if (!confirmResult.isConfirmed) {
    return;
  }

  // User clicked "Yes", proceed with admission
  setLoading(true);
  try {
    const res = await axios.post(admitPatient, {
      patientId: selectedPatient.id,
      admissionStatus,
      admissionDate,
      admissionTime,
      admissionNote,
      treatmentPlan,
      dat: selectedPatient.visitDate,
      insu: selectedPatient.insurance,
      name: selectedPatient.fullName,
      age: selectedPatient.age,
      gender: selectedPatient.gender,
      currentUser,
      complaint,
      exam,
      other,
      Diagnosis,
      procedure_
    });

    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: "Patient Admitted",
        text: "Patient admitted successfully.",
        timer: 2000,
        showConfirmButton: false
      });

      // Reset form after success
      setAdmissionStatus("");
      setAdmissionDate("");
      setAdmissionTime("");
      setAdmissionNote("");
      setTreatmentPlan("");
      setActiveTab(0);
      clearSelectedPatientData();
    } else {
      Swal.fire("Error", res.data.message, "error");
    }

  } catch (err) {
    Swal.fire("Error", "Failed to admit patient.", "error");
    console.error(err);
  } finally {
    setLoading(false);
  }
};


const clearSelectedPatientData = () => {
  setSelectedPatient(null);
  
  setPatientSearchTerm("");
  setActiveTab(0);

  // Clear diagnosis fields
  setComplaint("");
  setHistory("");
  setExam("");
  setOther("");
  setSelectedDiagnoses([]);
  setSelectedProcedures([]);

  // Clear services
  setServiceProvided("");
  setAttendanceType("");

  // Clear labs
  setLabs([]);
  setRequestedLabs([]);

  // Clear scans
  setscans([]);
  setRequestedScans([]);

  // Clear medications
  setMedications([]);
  setRequestedMeds([]);
  setSelectedMed(null);
  setDose("");
  setFrequency("");
  setDays("");
  setQty(0);
  setRoute("");

  // Clear appointments
  setAppointments([]);
  setAppointmentDate("");
  setAppointmentTime("");
  setAppointmentType("");
  setAppointmentReason("");
  setAppointmentOther("");
  setSendReminder(false);
  setEditingAppointmentId(null);

  // Clear other services
  setservices([]);
  setRequestedServices([]);
  setAiOPDNoteGenCount(0);
  setAiOPDIncludeOther(false);
  console.log("All patient data cleared!");
};


const handleAIGenerateOPDNote = async () => {
  // ── License check ──────────────────────────────────────────────
  try {
    const licenseAI = JSON.parse(localStorage.getItem('license_ai') || '{"allowed":true}');
    if (licenseAI.allowed === false) {
      Swal.fire({
        icon: 'error',
        title: '🔒 AI Features License Expired',
        html: `<p style="color:#64748b;font-size:14px">${licenseAI.reason || 'Your AI license has expired. Contact TotalCare support.'}</p>`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return;
    }
  } catch { /* allow */ }

  // ── Require diagnosis ──────────────────────────────────────────
  if (!selectedDiagnoses || selectedDiagnoses.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Diagnosis Required',
      text: 'Please select at least one diagnosis before generating the AI note.',
      confirmButtonColor: '#1A9B7F',
    });
    return;
  }

  // ── Limit: OPD generates once ──────────────────────────────────
  if (aiOPDNoteGenCount >= 1) {
    Swal.fire({
      icon: 'info',
      title: 'Already Generated',
      html: '<p style="color:#64748b;font-size:14px">An AI note has already been generated for this patient. Edit the fields directly if adjustments are needed.</p>',
      confirmButtonColor: '#1A9B7F',
    });
    return;
  }

  setAiGeneratingOPDNote(true);

  try {
    // ── Determine if existing notes should be refined or generated fresh
    const hasExistingNotes = !!(complaint?.trim() || history?.trim() || exam?.trim() || other?.trim());
    const hasProcedures    = selectedProcedures && selectedProcedures.length > 0;

    const payload = {
      // ── Patient demographics ──────────────────────────────────
      patientId:        selectedPatient.id,
      age:              selectedPatient.age,
      gender:           selectedPatient.gender,

      // ── Visit context ─────────────────────────────────────────
      attendanceType,       // e.g. "Chronic Follow-up", "Emergency/Acute Episode", "Antenatal"
      serviceProvided,      // e.g. "Outpatient Consultation", "Wound Dressing", "ANC"

      // ── Clinical data ─────────────────────────────────────────
      diagnoses:   selectedDiagnoses.map(d => ({ id: d.id, name: d.name, code: d.code })),
      procedures:  hasProcedures
                     ? selectedProcedures.map(p => ({ id: p.id, name: p.name, code: p.code }))
                     : [],
      hasProcedures,

      // ── Existing notes (refine, don't replace) ────────────────
      hasExistingNotes,
      opdComplaint: complaint?.trim() || '',
      opdHistory:   history?.trim()   || '',
      opdExam:      exam?.trim()      || '',
      opdOther:     other?.trim()     || '',

      // ── Flags ─────────────────────────────────────────────────
      includeSurgicalNotes:  false,
        actionDate:            selectedPatient.visitDate,
        isDischarge:           false,
        isDetention:           false,
        isOPD:                 true,   // ← always true here — this is the consultation tab note
        generationIndex:       0,
        excludeNamesFromNotes: true,
    };

    const res = await axios.post(generateNote, payload);

    if (res?.data?.success) {
      const ai = res.data.data || {}

      // ── Only overwrite if AI returned something non-empty ─────
      if (ai.complaint?.trim())       { setComplaint(ai.complaint);       setHasEdited(true); }
      if (ai.physicalExam?.trim())    { setExam(ai.physicalExam);         setHasEdited(true); }
      if (ai.patientHistory?.trim())  { setHistory(ai.patientHistory);    setHasEdited(true); }  // ← correct
      if (aiOPDIncludeOther && ai.otherDocumentation?.trim()) {
        setOther(ai.otherDocumentation);
        setHasEdited(true);
      }

      setAiOPDNoteGenCount(c => c + 1);

      Swal.fire({
        icon: 'success',
        title: hasExistingNotes ? 'Notes Refined' : 'Notes Generated',
        text: hasExistingNotes
          ? 'Existing notes have been refined using diagnosis and procedure context.'
          : 'OPD consultation note generated successfully.',
        timer: 2000,
        showConfirmButton: false,
      });
    } else {
      ErrorMessage('Generation Failed', res?.data?.message || 'Unable to generate note.');
    }
  } catch (error) {
    if (error.response?.status === 403 && error.response?.data?.licenseBlocked) {
      Swal.fire({ icon: 'error', title: '🔒 AI License Expired', text: 'Contact TotalCare support.', confirmButtonColor: '#d33' });
      return;
    }
    console.error('OPD AI generation error:', error);
    ErrorMessage('Error', 'Failed to generate AI note.');
  } finally {
    setAiGeneratingOPDNote(false);
  }
};

  return (
  <Box sx={{ 
  bgcolor: "#f5f5f5", 
  minHeight: "100vh", 
  p: 2,
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0.7)'
    },
    '50%': {
      transform: 'scale(1.05)',
      boxShadow: '0 0 0 10px rgba(255, 152, 0, 0)'
    },
    '100%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0)'
    }
  }
}}>
      {loading && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          bgcolor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(2px)",
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <CircularProgress size={70} thickness={5} />
      </Box>
)}

  <Container maxWidth="xl">
        
  <Box sx={{ 
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center',
  mb: 3,
  flexWrap: 'wrap',
  gap: 2
}}>
  {/* Title */}
  <Typography variant="h6" sx={{ fontWeight: 300 }}>
    OutPatient Consultation
  </Typography>

  {/* Stats Cards */}
  <Box sx={{ 
    display: 'flex', 
    gap: 1.5,
    flexWrap: 'wrap'
  }}>
    {/* Total Outpatients */}
    <Paper
      elevation={2}
      sx={{
        px: 2,
        py: 1,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        borderRadius: 2,
        minWidth: 120,
        textAlign: 'center',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }
      }}
    >
      <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
        Total
      </Typography>
      <Typography variant="h5" fontWeight={700}>
        {outpatientStats.totalOutpatients}
      </Typography>
    </Paper>

    {/* Male Count */}
    <Paper
      elevation={2}
      sx={{
        px: 2,
        py: 1,
        background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
        color: 'white',
        borderRadius: 2,
        minWidth: 100,
        textAlign: 'center',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }
      }}
    >
      <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
        Male
      </Typography>
      <Typography variant="h5" fontWeight={700}>
        {outpatientStats.maleCount}
      </Typography>
    </Paper>

    {/* Female Count */}
    <Paper
      elevation={2}
      sx={{
        px: 2,
        py: 1,
        background: 'linear-gradient(135deg, #F44336 0%, #D32F2F 100%)',
        color: 'white',
        borderRadius: 2,
        minWidth: 100,
        textAlign: 'center',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }
      }}
    >
      <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
        Female
      </Typography>
      <Typography variant="h5" fontWeight={700}>
        {outpatientStats.femaleCount}
      </Typography>
    </Paper>

    {/* Pediatrics Count */}
    <Paper
      elevation={2}
      sx={{
        px: 2,
        py: 1,
        background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
        color: 'white',
        borderRadius: 2,
        minWidth: 100,
        textAlign: 'center',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }
      }}
    >
      <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
        Pediatrics
      </Typography>
      <Typography variant="h5" fontWeight={700}>
        {outpatientStats.pediatricsCount}
      </Typography>
    </Paper>

    {/* Adult Count */}
    <Paper
      elevation={2}
      sx={{
        px: 2,
        py: 1,
        background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
        color: 'white',
        borderRadius: 2,
        minWidth: 100,
        textAlign: 'center',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }
      }}
    >
      <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
        Adults
      </Typography>
      <Typography variant="h5" fontWeight={700}>
        {outpatientStats.adultCount}
      </Typography>
    </Paper>
  </Box>
</Box>

        {/* --- Patient Search Box --- */}
<Paper 
  elevation={filterExpanded ? 4 : 2}
  sx={{ 
    mb: 2, 
    borderRadius: 2,
    position: 'sticky',
    top: 0,
    zIndex: 1100,
    transition: 'all 0.3s ease',
    border: '1px solid',
    borderColor: filterExpanded ? 'primary.main' : 'divider',
    overflow: 'hidden',
  }}
>
  {/* Compact Header - Always Visible */}
  <Box 
    sx={{ 
      px: 2, 
      py: 1,
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      bgcolor: filterExpanded ? 'primary.main' : '#f5f5f5',
      color: filterExpanded ? 'white' : 'text.primary',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        bgcolor: filterExpanded ? 'primary.dark' : '#eeeeee',
      }
    }}
    onClick={() => setFilterExpanded(!filterExpanded)}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Search sx={{ fontSize: 20 }} />
      <Typography variant="subtitle2" fontWeight={600}>
        Patient Filter
      </Typography>

      {/* Show selected filters summary when collapsed */}
      {!filterExpanded && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
          {selectedMonth && (
            <Chip 
              label={outpatientMonths.find(m => m.value === selectedMonth)?.label || selectedMonth} 
              size="small" 
              sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'primary.main', color: 'white' }} 
            />
          )}
          {selectedDate && (
            <Chip 
              label={selectedDate} 
              size="small" 
              sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'info.main', color: 'white' }} 
            />
          )}
          {selectedPatient && (
            <Chip 
              label={`${selectedPatient.fullName} (${selectedPatient.id})`} 
              size="small" 
              sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'success.main', color: 'white' }} 
            />
          )}
        </Box>
      )}
    </Box>

    {!filterExpanded && (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
    {selectedMonth && (
      <Chip 
        label={outpatientMonths.find(m => m.value === selectedMonth)?.label || selectedMonth} 
        size="small" 
        sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'primary.main', color: 'white' }} 
      />
    )}
    {selectedDate && (
      <Chip 
        label={selectedDate} 
        size="small" 
        sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'info.main', color: 'white' }} 
      />
    )}

    {/* ✅ ADD HERE — after selectedDate chip */}
    {serviceTypeFilter && (
      <Chip
        label={serviceTypeFilter}
        size="small"
        sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'secondary.main', color: 'white' }}
      />
    )}

    {selectedPatient && (
      <Chip 
        label={`${selectedPatient.fullName} (${selectedPatient.id})`} 
        size="small" 
        sx={{ height: 22, fontSize: '0.7rem', bgcolor: 'success.main', color: 'white' }} 
      />
    )}
  </Box>
)}
  </Box>

  {/* Expandable Content */}
  <Box sx={{ 
    maxHeight: filterExpanded ? 500 : 0,
    overflow: 'hidden',
    transition: 'max-height 0.4s ease',
  }}>
    <Box sx={{ p: 2 }}>
      {/* Filter Row */}
      <Grid container spacing={1.5} columns={{ xs: 4, sm: 8, md: 12 }} alignItems="center">
        
        {/* Month/Year Selector */}
        <Grid item xs={12} sm={4} md={3} size={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Month / Year</InputLabel>
            <Select
              value={selectedMonth}
              label="Month / Year"
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <MenuItem value="">
                <em>Select Month</em>
              </MenuItem>
              {outpatientMonths.map((row, index) => (
                <MenuItem key={index} value={row.value}>
                  {row.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Date Selector */}
        <Grid item xs={12} sm={4} md={3} size={3}>
          <FormControl fullWidth size="small" disabled={!selectedMonth}>
            <InputLabel>Date</InputLabel>
            <Select
              value={selectedDate}
              label="Date"
              onChange={(e) => setSelectedDate(e.target.value)}
            >
              <MenuItem value="">
                <em>All Dates</em>
              </MenuItem>
              {outpatientDates.map((row, index) => (
                <MenuItem key={index} value={row.visit_date}>
                  {row.visit_date} ({row.patient_count})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Patient Search */}
        {/* Patient Search */}
<Grid item xs={12} sm={4} md={4} size={4}>
  <TextField
    fullWidth
    size="small"
    placeholder="Search by ID, Name, or Tel..."
    value={patientSearchTerm}
    onChange={(e) => {
      setPatientSearchTerm(e.target.value);
      setPatientPage(0);
    }}
    InputProps={{
      startAdornment: <Search sx={{ color: 'action.active', mr: 1 }} />
    }}
  />
</Grid>

{/* State Filter */}
<Grid item xs={12} sm={4} md={2} size={2}>
  <FormControl fullWidth size="small">
    <InputLabel>Patient Type</InputLabel>
    <Select
      value={stateFilter}
      label="Patient Type"
      onChange={(e) => {
        setStateFilter(e.target.value);
        setPatientPage(0);
      }}
      sx={{ fontWeight: 600 }}
    >
      <MenuItem value="all">All Patients</MenuItem>
      <MenuItem value="outpatient">OutPatient</MenuItem>
      <MenuItem value="inpatient">InPatient</MenuItem>
    </Select>
  </FormControl>
</Grid>

{/* Service Type Filter */}
<Grid item xs={12} sm={4} md={2} size={2}>
  <FormControl fullWidth size="small" disabled={serviceTypeOptions.length === 0}>
    <InputLabel>Service Type</InputLabel>
    <Select
      value={serviceTypeFilter}
      label="Service Type"
      onChange={(e) => {
        setServiceTypeFilter(e.target.value);
        setPatientPage(0);
      }}
      sx={{ fontWeight: 600 }}
    >
      <MenuItem value="">All Services</MenuItem>
      {serviceTypeOptions.map((svc, idx) => (
        <MenuItem key={idx} value={svc} sx={{ fontSize: '0.85rem' }}>
          {svc}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
      </Grid>

      {/* Patient Table */}
      <TableContainer sx={{ 
        maxHeight: 280, 
        mt: 1.5, 
        borderRadius: 1, 
        border: '1px solid', 
        borderColor: 'divider' 
      }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {['Patient ID', 'Name', 'Gender', 'Age', 'Insurance', 'Tel', 'Visit Date'].map(col => (
                <TableCell key={col} sx={{ fontWeight: 700, fontSize: '0.75rem', bgcolor: '#f5f5f5', py: 0.75 }}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingPatients ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                  <CircularProgress size={30} />
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                    Loading patients...
                  </Typography>
                </TableCell>
              </TableRow>
            ) : paginatedPatientList.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                  <Person sx={{ fontSize: 36, color: 'text.disabled' }} />
                  <Typography variant="caption" color="text.secondary" display="block">
                    {selectedMonth ? 'No patients found' : 'Select a month to load patients'}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              paginatedPatientList.map((patient) => (
                <TableRow
                  key={`${patient.id}-${patient.visitDate}`}
                  hover
                  selected={selectedPatient?.id === patient.id && selectedPatient?.visitDate === patient.visitDate}
                  onClick={() => {
                    clearSelectedPatientData();
                    setSelectedPatient(patient);
                    setFilterExpanded(false); // ✅ Auto-collapse on patient select
                  }}
                  sx={{
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    bgcolor: (selectedPatient?.id === patient.id && selectedPatient?.visitDate === patient.visitDate)
                      ? 'rgba(25, 118, 210, 0.12)'
                      : 'inherit',
                    '&:hover': {
                      bgcolor: 'rgba(25, 118, 210, 0.08)',
                    },
                    '&:nth-of-type(odd)': {
                      bgcolor: (selectedPatient?.id === patient.id && selectedPatient?.visitDate === patient.visitDate)
                        ? 'rgba(25, 118, 210, 0.12)'
                        : 'rgba(0, 0, 0, 0.02)'
                    }
                  }}
                >
                  <TableCell sx={{ fontWeight: 600, color: 'primary.main', fontSize: '1 rem', py: 0.5 }}>
                    {patient.id}
                  </TableCell>
                  <TableCell sx={{ py: 0.5 }}>
                    <Box display="flex" alignItems="center" gap={0.75}>
                      <Avatar sx={{ width: 24, height: 24, bgcolor: 'primary.main', fontSize: '1 rem' }}>
                        {patient.fullName?.charAt(0) || 'P'}
                      </Avatar>
                      <Typography variant="caption" fontWeight={500}>
                        {patient.fullName}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ py: 0.5 }}>
                    <Chip
                      size="small"
                      label={patient.gender}
                      color={patient.gender === 'MALE' ? 'info' : 'error'}
                      sx={{ fontSize: '1 rem', height: 20 }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: '1 rem', py: 0.5 }}>{patient.age}</TableCell>
                  <TableCell sx={{ py: 0.5 }}>
                    <Chip
                      size="small"
                      label={patient.insurance}
                      sx={{ fontSize: '1 rem', height: 20, bgcolor: 'rgba(255, 152, 0, 0.15)', color: '#e65100' }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: '1 rem', py: 0.5 }}>{patient.tel}</TableCell>
                  <TableCell sx={{ py: 0.5 }}>
                    <Chip
                      size="small"
                      label={patient.visitDate}
                      variant="outlined"
                      sx={{ fontSize: '1 rem', height: 20, borderColor: 'primary.main', color: 'primary.main' }}
                    />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {filteredByState.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600}>
            {patientPage * patientRowsPerPage + 1}-
            {Math.min((patientPage + 1) * patientRowsPerPage, filteredByState.length)} of {filteredByState.length}
          </Typography>
          <TablePagination
            component="div"
           count={filteredByService.length}
            page={patientPage}
            onPageChange={(e, newPage) => setPatientPage(newPage)}
            rowsPerPage={patientRowsPerPage}
            onRowsPerPageChange={(e) => {
              setPatientRowsPerPage(parseInt(e.target.value, 10));
              setPatientPage(0);
            }}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={{
              border: 'none',
              '& .MuiTablePagination-toolbar': { minHeight: 32, px: 0 },
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                fontSize: '0.7rem',
                fontWeight: 600
              }
            }}
          />
        </Box>
      )}
    </Box>
  </Box>
</Paper>

       
{/* --- Enhanced Patient Info Card --- */}
{selectedPatient && (
  <Card 
    sx={{ 
      mb: 3, 
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      borderRadius: 3,
      overflow: 'hidden'
    }}
  >
    {/* Header Section with Gradient Background */}
    <Box
      sx={{
        p: 3,
        borderBottom: '3px solid',
        borderColor: 'primary.main',
        bgcolor: '#f8f9fa'
      }}
    >
      <Grid container spacing={3} alignItems="flex-start" columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* Patient Biodata */}
        <Grid item xs={12} md={3} size={4}>
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                width: 64,
                height: 64,
                fontSize: 24,
                fontWeight: 700,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
              }}
            >
              {selectedPatient.fullName
                .split(" ")
                .map((n) => n[0])
                .join("")
                .slice(0, 2)}
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 0.5 }}>
                {selectedPatient.fullName}
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {selectedPatient.age} year(s) • Patient ID: {selectedPatient.id}
              </Typography>
              <Stack direction="row" spacing={1}>
                <Chip
                  size="small"
                  label={selectedPatient.gender}
                  sx={{
                    bgcolor: selectedPatient.gender === "MALE" 
                      ? 'rgba(33, 150, 243, 0.9)' 
                      : 'rgba(244, 67, 54, 0.9)',
                    color: 'white',
                    fontWeight: 600
                  }}
                />
                <Chip
                  size="small"
                  label={selectedPatient.insurance}
                  sx={{ 
                    bgcolor: 'rgba(255, 152, 0, 0.9)', 
                    color: 'white',
                    fontWeight: 600
                  }}
                />

              </Stack>

      {/* Show Ward Rounds button only for inpatients/detention */}
      {!isCurrentPatientOPD && (
        <Button
          variant="contained"
          startIcon={<LocalHospital />}
          fullWidth
          sx={{
            mt: 2,
            background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
            color: "white",
            px: 3, py: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
            borderRadius: 3,
            textTransform: "none",
            boxShadow: "0 4px 15px rgba(17, 153, 142, 0.4)",
            transition: "all 0.3s ease",
            "&:hover": { transform: "translateY(-2px)" },
          }}
          onClick={() => setWardRoundsOpen(true)}
        >
          Ward Rounds / Information
        </Button>
      )}
            
            </Box>
          </Box>
        </Grid>

        {/* Contact & Visit Information */}
        <Grid item xs={12} md={3} size={3} >
          <Stack spacing={1.5}>
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                Contact Information
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                📞 {selectedPatient.tel}
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                📍 {selectedPatient.location}
              </Typography>
            </Box>
            
            <Box>
              <Chip
                label={selectedPatient.state}
                sx={{ 
                  bgcolor: 'rgba(185, 49, 39, 0.9)',
                  color: 'white',
                  fontWeight: 600,
                  mb: 1
                }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Visit Date: {selectedPatient.visitDate}
              </Typography>
         
          <Button
            variant="outlined"
            color="warning"
            size="small"
            onClick={() => setPrecautionDialogOpen(true)}
            sx={{
              mt: 1,
              textTransform: 'none',
              fontWeight: 600,
              borderWidth: 2,
              '&:hover': {
                borderWidth: 2,
                transform: 'scale(1.02)',
                boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)'
              },
              transition: 'all 0.2s ease'
            }}
          >
          ⚠️ Special Precaution
          </Button>
   
             
            </Box>
          </Stack>
        </Grid>

       
    
        {/* Vital Signs Preview */}
        <Grid item xs={12} md={3} size={3}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h6" fontWeight={700} color="primary">
              Vital Signs
            </Typography>
           
          </Box>
         <Stack spacing={1}>
            <Typography variant="body2">
                <strong>Temperature:</strong> {selectedPatient?.vitals?.temperature ?? "-"}°C
                </Typography>

                <Typography variant="body2">
                <strong>Blood Pressure:</strong> {selectedPatient?.vitals?.bp ?? "-"} mmHg
                </Typography>

                <Typography variant="body2">
                <strong>Pulse:</strong> {selectedPatient?.vitals?.pulse ?? "-"} bpm
                </Typography>
                    
                <Typography variant="body2">
                <strong>Respiration Rate:</strong> {selectedPatient?.vitals?.respiration ?? "-"} breaths/min
                </Typography>

          </Stack>
        </Grid>
        <Grid item xs={12} md={3} >

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h6" fontWeight={700} color="primary">
              
            </Typography>
            <IconButton
              color="primary"
              size="small"
              onClick={() => setVitalsHistoryOpen(true)}
              title="View Vital Signs History"
              sx={{
                bgcolor: 'primary.main',
                color: 'white',
                '&:hover': {
                  bgcolor: 'primary.dark',
                }
              }}
            >
              <History />
            </IconButton>
          </Box>
         
          <Stack spacing={1}>
            
            <Typography variant="body2">
              <strong> Weight:</strong> {selectedPatient?.vitals?.weight ??  "-"} kg
            </Typography>
            <Typography variant="body2">
              <strong>Height:</strong> {selectedPatient?.vitals?.height ??  "-"} cm
            </Typography>
             <Typography variant="body2">
                <strong>BMI:</strong> {selectedPatient?.vitals?.bmi ?? "-"}
                </Typography>
           
          </Stack>
        </Grid>

      </Grid>
    </Box>

    {/* Body Section - Full Vital Signs Details */}
   <CardContent>
  <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
   

    {/* AI Analysis Section - Full Width Below */}
    <Grid item xs={12} size={12}>
      <Box
        sx={{
          p: 2.5,
          background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
          borderRadius: 2,
          border: '2px solid #90caf9',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <AutoAwesome 
          sx={{ 
            color: 'primary.main',
            fontSize: 28,
            mt: 0.5
          }} 
        />
        <Box flex={1}>
          <Typography 
            variant="subtitle1" 
            fontWeight={700}
            color="primary"
            sx={{ mb: 1 }}
          >
            AI-Powered Analysis
          </Typography>
          <Typography 
            variant="body2"
            sx={{ 
              lineHeight: 1.7,
              color: 'text.primary'
            }}
          >
           {selectedPatient?.vitals ? analyzeVitals(selectedPatient.vitals) : "No vitals data available"}
          </Typography>
        </Box>
      </Box>
    </Grid>
  </Grid>
</CardContent>
  </Card>
)}
        

 {/* --- Consultation Section --- */}
    
{selectedPatient ? (
  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, minHeight: '70vh' }}>
    {/* Sidebar Tabs */}
    <Paper
      sx={{
        width: { xs: '100%', sm: 64, md: 64 },
        flexShrink: 0,
        borderRadius: { xs: 0, sm: 1 },
        mr: { sm: 2 },
        mb: { xs: 2, sm: 0 },
        maxHeight: { sm: '70vh' },
        overflow: 'auto',
        transition: 'width 0.3s ease',
        '&:hover': {
          width: { sm: 200, md: 240 },
          // Show all tab labels when hovering over the Paper container
          '& .MuiTab-root': {
            fontSize: { sm: '0.875rem' },
            justifyContent: { sm: 'flex-start' },
            paddingLeft: { sm: '16px' },
            '& .MuiTab-iconWrapper': {
              marginRight: { sm: '12px' }
            }
          }
        }
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(e, v) => {
          if (!ensureServiceAndAttendanceSelected()) return;
          setActiveTab(v);
        }}
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          '& .MuiTab-root': {
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: { xs: '100%', sm: 64, md: 64 },
            minHeight: { xs: 52, sm: 64, md: 64 },
            fontSize: { xs: '0.75rem', sm: '0' },
            padding: { xs: '10px 12px', sm: '12px 8px' },
            borderBottom: '1px solid',
            borderBottomColor: 'divider',
            transition: 'all 0.3s ease',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            '& .MuiTab-iconWrapper': {
              marginBottom: { xs: 0, sm: 0 },
              marginRight: { xs: '8px', sm: 0 }
            },
            '&.Mui-selected': {
              backgroundColor: 'action.selected',
              fontWeight: 600,
            }
          },
        }}
      >
        <Tab
          label="Consultation"
          icon={<LocalHospital />}
          iconPosition="start"
        />
        <Tab
          label="Laboratory"
          icon={<Science />}
          iconPosition="start"
        />
        <Tab
          label="Scan"
          icon={<CameraAlt />}
          iconPosition="start"
        />
        <Tab
          label="Medication"
          icon={<Medication />}
          iconPosition="start"
        />
        <Tab
          label="Other Service"
          icon={<RoomService />}
          iconPosition="start"
        />
        <Tab
          label="Appointment"
          icon={<CalendarMonth />}
          iconPosition="start"
        />
        <Tab
          label="Admit Patient"
          icon={<Hotel />}
          iconPosition="start"
        />
        <Tab
          label="Referee"
          icon={<PersonAdd />}
          iconPosition="start"
        />
      </Tabs>
    </Paper>

    {/* Main Content Area */}
    <Paper sx={{ flexGrow: 1, p: { xs: 2, sm: 3 } }}>
      {/* --- Quick Access Buttons --- */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          mb: 2,
          justifyContent: "flex-start",
        }}
      >
        <Tooltip title="View full medical record history">
          <Button
          variant="outlined"
          color="primary"
          onClick={() => setMedHistoryOpen(true)}
          startIcon={<Notes />}
        >
          Medical History
        </Button>
        </Tooltip>

         <Tooltip title="Review past Vitals results">
          <Button
            variant="outlined"
            color="success"
           
            startIcon={<History />}
             onClick={() => setVitalsHistoryOpen(true)}
          >
            Vitals History
          </Button>
        </Tooltip>

        <Tooltip title="Review past laboratory results">
          <Button
            variant="outlined"
            color="secondary"
           
            startIcon={<Science />}
             onClick={() => setlabHistoryOpen(true)}
          >
            Lab History
          </Button>
        </Tooltip>

        <Tooltip title="View previous scan/imaging results">
          <Button
            variant="outlined"
            color="info"
             onClick={() => setScanHistoryOpen(true)}
            startIcon={<CameraAlt />}
          >
            Scan History
          </Button>
        </Tooltip>

        <Tooltip title="Check previous medications prescribed">
          <Button
            variant="outlined"
            color="success"
            onClick={() => setopenmedHis(true)}
            startIcon={<Medication />}
          >
            Medication History
          </Button>
        </Tooltip>

      </Box>

      <Divider sx={{ my: 3}} />
   
{/* Tab Content Goes Here - Add your activeTab === 0, 1, 2, etc. */}
{activeTab === 0 && (
  <Box>
    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

{/* Service Provided */}
 <Grid item xs={12} md={6} size={6}>
 <FormControl fullWidth>
  <InputLabel>Select Service Provided</InputLabel>
  <Select
    value={serviceProvided}
    label="Select Service Provided"
    onChange={(e) => {
      const newService = e.target.value;
      setServiceProvided(newService);

      // ✅ Pass both current values explicitly
      if (attendanceType && newService) {
        saveServiceProvided(false, attendanceType, newService);
      }
    }}
  >
    <MenuItem value="">Select Service Provided</MenuItem>
    {insuredServices.length > 0 ? (
      insuredServices.map((srv) => (
        <MenuItem key={srv.id} value={srv.name}>
          {srv.name}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No services found for this insurance</MenuItem>
    )}
  </Select>
</FormControl>


</Grid>


{/* Type of Attendance */}
<Grid item xs={12} md={6} size={6}>
       
<FormControl fullWidth>
  <InputLabel>Type of Attendance</InputLabel>
  <Select
    value={attendanceType}
    label="Type of Attendance"
    onChange={(e) => {
      const newType = e.target.value;
      setAttendanceType(newType);

      // ✅ Pass both new values explicitly
      if (serviceProvided && newType) {
        saveServiceProvided(false, newType, serviceProvided);
      }
    }}
  >
    <MenuItem value="">Select Type Of Attendance</MenuItem>
    <MenuItem value="Chronic Follow-up">Chronic Follow-up</MenuItem>
    <MenuItem value="Emergency/Acute Episode">Emergency/Acute Episode</MenuItem>
    <MenuItem value="Antenatal">Antenatal</MenuItem>
    <MenuItem value="Postnatal">Postnatal</MenuItem>
  </Select>
</FormControl>

    
</Grid>

{/* Complaint */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.complaint}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        handleSuggest("complaint", newInputValue);
        setComplaint(newInputValue);
        setHasEdited(true);
      }
    }}
    
    onChange={(event, newValue, reason) => {
      if (newValue && reason === "selectOption") {
        setComplaint((prev) => {
          const parts = prev.split(/[.,]/);
          parts[parts.length - 1] = ` ${newValue}`;
          return parts.join(", ");
        });
        setHasEdited(true);
      }
    }}

    inputValue={complaint}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Complaint"
        multiline
        rows={6}
        placeholder="Enter patient complaint(s)... separate by , or ."
        name="complaint"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>

{/* History */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.history}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        setHistory(newInputValue);
        setHasEdited(true); // ✅ added
      }
    }}
   onChange={(event, newValue, reason) => {
  if (newValue && reason === "selectOption") {
    setHistory((prev) => {
      const parts = prev.split(/[.,]/);
      parts[parts.length - 1] = ` ${newValue}`;
      return parts.join(", ");
    });
    setHasEdited(true);
  }
}}
    inputValue={history}
    renderInput={(params) => (
      <TextField
        {...params}
        label="History"
        multiline
        rows={6}
        placeholder="Enter patient history... separate by , or ."
        name="history"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
        
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>

{/* Physical Examination */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.exam}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        setExam(newInputValue);
        setHasEdited(true); // ✅ added
      }
    }}

   onChange={(event, newValue, reason) => {
  if (newValue && reason === "selectOption") {
    setExam((prev) => {
      const parts = prev.split(/[.,]/);
      parts[parts.length - 1] = ` ${newValue}`;
      return parts.join(", ");
    });
    setHasEdited(true);
  }
}}

    inputValue={exam}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Physical Examination"
        multiline
        rows={6}
        placeholder="Enter findings... separate by , or ."
        name="exam"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
          
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>

{/* Other Documentation */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.other}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        setOther(newInputValue);
        setHasEdited(true); // ✅ added
      }
    }}
   onChange={(event, newValue, reason) => {
  if (newValue && reason === "selectOption") {
    setOther((prev) => {
      const parts = prev.split(/[.,]/);
      parts[parts.length - 1] = ` ${newValue}`;
      return parts.join(", ");
    });
    setHasEdited(true);
  }
}}
    inputValue={other}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Other Documentation"
        multiline
        rows={6}
        placeholder="Enter additional notes... separate by , or ."
        name="other"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
         
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>


{/* Diagnosis(es) */}
<Grid item xs={12} md={6} size={12} >
  <Typography variant="subtitle1" gutterBottom>
    Diagnosis(es)
  </Typography>

  <Autocomplete
    multiple
    options={diagnosisOptions}
    value={selectedDiagnoses || []}
    onChange={(event, newValue) => {
      setSelectedDiagnoses(newValue);
      saveOrUpdateDiagnosis(newValue); // ✅ CALL FUNCTION HERE
    }}
    getOptionLabel={(option) =>
      option && option.code && option.name
        ? `${option.name}`
        : ""
    }
    filterSelectedOptions
    isOptionEqualToValue={(option, value) => option.id === value.id}
    filterOptions={(options, { inputValue }) => {
      const search = inputValue.toLowerCase();
      return options.filter(
        (opt) =>
          opt.name.toLowerCase().includes(search) ||
          opt.code.toLowerCase().includes(search) ||
          (opt.cat && opt.cat.toLowerCase().includes(search)) ||
          (opt.core && opt.core.toString().toLowerCase().includes(search))
      );
    }}
    renderInput={(params) => (
      <TextField {...params} placeholder="Search by code or diagnosis name..." />
    )}
    renderOption={(props, option) => (
      <li {...props} key={option.id}>
        <Box>
          <Typography variant="body2" color="bold">
            {option.name}
          </Typography>
        </Box>
      </li>
    )}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          key={option.id}
          label= {option.name}
          {...getTagProps({ index })}
          size="small"
        />
      ))
    }
  />
</Grid>


{/* Procedure(s) */}
<Grid item xs={12} md={6} size={12}>
  <Typography variant="subtitle1" gutterBottom>
    Procedure(s)
  </Typography>

  <Autocomplete
    multiple
    options={procedureOptions}
    value={selectedProcedures || []}
    onChange={(event, newValue) => {
      setSelectedProcedures(newValue);
      saveOrUpdateProcedure(newValue); // ✅ SAVE ON CHANGE
    }}
    getOptionLabel={(option) =>
      option && option.name ? `${option.name}` : ""
    }
    filterSelectedOptions
    isOptionEqualToValue={(option, value) => option.id === value.id}
    filterOptions={(options, { inputValue }) => {
      const search = inputValue.toLowerCase();
      return options.filter((opt) =>
        opt.name && opt.name.toLowerCase().includes(search)
      );
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder="Search by procedure code or name..."
      />
    )}
    renderOption={(props, option) => (
      <li {...props} key={option.id}>
        <Box>
          <Typography variant="body2" color="bold">
            {option.name}
          </Typography>
        </Box>
      </li>
    )}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          key={option.id}
          label={option.name}
          {...getTagProps({ index })}
          size="small"
        />
      ))
    }
  />
</Grid>

{/* ─── OPD AI Note Generator (only for pure outpatients) ─────── */}

  <Grid item xs={12} size={12}>
    <Paper
      elevation={4}
      sx={{
        p: 2.5,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #f8f9ff 0%, #f0fff4 100%)',
        border: '2px solid',
        borderColor: aiOPDNoteGenCount >= 1 ? '#c8e6c9' : '#d0e2ff',
        position: 'sticky',
        bottom: 16,
        zIndex: 10,
        boxShadow: '0 8px 32px rgba(26,155,127,0.15)',
        transition: 'all 0.3s',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>

        {/* Left: info */}
        <Box sx={{ flex: 1, minWidth: 200 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <AutoAwesome sx={{ color: '#1A9B7F', fontSize: 22 }} />
            <Typography variant="subtitle2" fontWeight={700} color="#1A9B7F">
              Generate Outpatient Note with AI
            </Typography>
            {aiOPDNoteGenCount >= 1 && (
              <Chip
                label="Generated ✓"
                size="small"
                sx={{ height: 20, fontSize: '0.65rem', fontWeight: 700, bgcolor: '#e8f5e9', color: '#2e7d32' }}
              />
            )}
          </Box>
          <Typography variant="caption" color="text.secondary">
            {selectedDiagnoses?.length > 0
              ? `Using ${selectedDiagnoses.length} diagnosis${selectedDiagnoses.length > 1 ? 'es' : ''}${selectedProcedures?.length > 0 ? ` and ${selectedProcedures.length} procedure${selectedProcedures.length > 1 ? 's' : ''}` : ''} — fills complaint, physical exam, and history fields.`
              : 'Select a diagnosis first to enable AI generation.'
            }
            {!isCurrentPatientOPD && (
              <span style={{ display: 'block', marginTop: 2, color: '#e65100' }}>
                Patient is admitted — this generates the pre-admission outpatient consultation note.
              </span>
            )}
          </Typography>
        </Box>

        {/* Right: checkbox + button */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={aiOPDIncludeOther}
                onChange={(e) => setAiOPDIncludeOther(e.target.checked)}
                size="small"
                sx={{ color: '#1A9B7F', '&.Mui-checked': { color: '#1A9B7F' } }}
              />
            }
            label={
              <Typography variant="caption" fontWeight={600}>
                Include Other Documentation
              </Typography>
            }
          />

          <Button
            variant="contained"
            onClick={handleAIGenerateOPDNote}
            disabled={
              aiGeneratingOPDNote ||
              aiOPDNoteGenCount >= 1 ||
              !selectedDiagnoses ||
              selectedDiagnoses.length === 0
            }
            startIcon={
              aiGeneratingOPDNote
                ? <CircularProgress size={16} color="inherit" />
                : aiOPDNoteGenCount >= 1
                  ? <History sx={{ fontSize: 18 }} />
                  : <AutoAwesome sx={{ fontSize: 18 }} />
            }
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: 2.5,
              px: 3,
              py: 1,
              fontSize: '0.9rem',
              background: aiOPDNoteGenCount >= 1
                ? '#e0e0e0'
                : 'linear-gradient(135deg, #1A9B7F 0%, #38ef7d 100%)',
              boxShadow: aiOPDNoteGenCount >= 1 ? 'none' : '0 4px 14px rgba(26,155,127,0.4)',
              transition: 'all 0.3s',
              '&:hover': {
                transform: aiOPDNoteGenCount >= 1 ? 'none' : 'translateY(-1px)',
                boxShadow: aiOPDNoteGenCount >= 1 ? 'none' : '0 6px 18px rgba(26,155,127,0.5)',
              },
              '&.Mui-disabled': {
                background: '#e0e0e0',
                color: '#aaa',
              }
            }}
          >
            {aiGeneratingOPDNote
              ? 'Generating...'
              : aiOPDNoteGenCount >= 1
                ? 'Note Generated'
                : 'Generate Note with AI'
            }
          </Button>
        </Box>
      </Box>
    </Paper>
  </Grid>


</Grid>
    
  </Box>
)}




{/* --- Laboratory --- */}
{activeTab === 1 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Labs (Left Side) --- */}
    <Grid item xs={12} md={6} size={5}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Labs
        </Typography>
        <TextField
          fullWidth
          placeholder="Search lab by name..."
          value={labSearchTerm}
          onChange={(e) => setLabSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="small"
        />

        {/* Responsive Table */}
        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Lab</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                  Request
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {labs
                .filter((lab) =>
                  lab.name.toLowerCase().includes(labSearchTerm.toLowerCase())
                )
                .slice(labPage * labRowsPerPage, labPage * labRowsPerPage + labRowsPerPage)
                .map((lab, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{lab.name}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}> {formatWithOutSom (lab.amount)}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleRequestLab(lab)} size="small">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={labs.filter((lab) =>
            lab.name.toLowerCase().includes(labSearchTerm.toLowerCase())
          ).length}
          page={labPage}
          onPageChange={(e, newPage) => setLabPage(newPage)}
          rowsPerPage={labRowsPerPage}
          onRowsPerPageChange={(e) => {
            setLabRowsPerPage(parseInt(e.target.value, 10));
            setLabPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Labs (Right Side) --- */}
    <Grid item xs={12} md={6} size={7}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Labs
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Lab</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedLabs
                .slice(reqPage * reqRowsPerPage, reqPage * reqRowsPerPage + reqRowsPerPage)
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.lab}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.labBy || "-"}</TableCell>
                    <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      <Tooltip title="Enter Lab Results">
                        <IconButton
                          color="success"
                          size="small"
                          onClick={() => handleEnterLabResults(req)}
                        >
                          <Science fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedLabs.length}
          page={reqPage}
          onPageChange={(e, newPage) => setReqPage(newPage)}
          rowsPerPage={reqRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqRowsPerPage(parseInt(e.target.value, 10));
            setReqPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals Section */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e3f2fd, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom (requestedLabs
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom (requestedLabs
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/* --- Scan --- */}
{activeTab === 2 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Scans (Left Side) --- */}
    <Grid item xs={12} md={6} size={5}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Scans
        </Typography>
        <TextField
          fullWidth
          placeholder="Search scan by name..."
          value={scanSearchTerm}
          onChange={(e) => setScanSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="small"
        />

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                  Request
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scans
                .filter((scan) =>
                  scan.name.toLowerCase().includes(scanSearchTerm.toLowerCase())
                )
                .slice(scanPage * scanRowsPerPage, scanPage * scanRowsPerPage + scanRowsPerPage)
                .map((scan, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{scan.name}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(scan.amount)}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleRequestScan(scan)} size="small">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={scans.filter((scan) =>
            scan.name.toLowerCase().includes(scanSearchTerm.toLowerCase())
          ).length}
          page={scanPage}
          onPageChange={(e, newPage) => setScanPage(newPage)}
          rowsPerPage={scanRowsPerPage}
          onRowsPerPageChange={(e) => {
            setScanRowsPerPage(parseInt(e.target.value, 10));
            setScanPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Scans (Right Side) --- */}
    <Grid item xs={12} md={6} size={7}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Scans
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedScans
                .slice(reqScanPage * reqScanRowsPerPage, reqScanPage * reqScanRowsPerPage + reqScanRowsPerPage)
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.lab}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.scanBy || "-"}</TableCell>
                    <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      <Tooltip title="Enter Scan Results">
                        <IconButton
                          color="success"
                          size="small"
                          onClick={() => handleEnterScanResults(req)}
                        >
                          <CameraAlt fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteScanRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedScans.length}
          page={reqScanPage}
          onPageChange={(e, newPage) => setReqScanPage(newPage)}
          rowsPerPage={reqScanRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqScanRowsPerPage(parseInt(e.target.value, 10));
            setReqScanPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #fff3e0, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom (requestedScans
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom (requestedScans
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/* --- Medication --- */}
{activeTab === 3 && (
  <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
    
    {/* --- Full View Button --- */}
   
     <Button
      fullWidth
      variant="outlined"
      color="primary"
      size="large"
      onClick={() => setMedDialogOpen(true)}
      sx={{
        py: 2,            // taller button
        fontSize: "1rem", // bigger text
        fontWeight: 600
      }}
    >
      Open Full Medication View
    </Button>
   

    {/* --- Available Medications (Column 1) --- */}
    <Grid item xs={12} md={4} size={3}>
     
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Available Medications
        </Typography>

        <TextField
          fullWidth
          placeholder="Search medication..."
          value={medSearchTerm}
          onChange={(e) => setMedSearchTerm(e.target.value)}
          size="big"
          margin="dense"
        />

        <TableContainer sx={{ maxHeight: 450 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Medication</TableCell>
                <TableCell align="center" sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                  Select
                </TableCell>
              </TableRow>
            </TableHead>
            {/* In activeTab === 3 - Available Medications */}
            <TableBody>
              {medications
                .filter((med) => med.name.toLowerCase().includes(medSearchTerm.toLowerCase()))
                .slice(medPage * medRowsPerPage, medPage * medRowsPerPage + medRowsPerPage)
                .map((med, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ 
                      "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
                      // ✅ Highlight chronic medications
                      backgroundColor: isMedicationChronic(med.name) ? '#e8f5e9' : 'inherit',
                      borderLeft: isMedicationChronic(med.name) ? '4px solid #4caf50' : 'none',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: isMedicationChronic(med.name) ? '#c8e6c9' : 'action.hover',
                      }
                    }}
                  >
                    <TableCell sx={{ fontSize: "0.8rem" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {med.name}
                      {isMedicationChronic(med.name) && (
                        <Chip 
                          label="Chronic drug" 
                          size="small" 
                          color="success" 
                          sx={{ 
                            height: 20, 
                            fontSize: '0.65rem',
                            fontWeight: 600
                          }} 
                        />
                      )}
                      <Tooltip title="Medication Info">
                        <IconButton
                          size="small"
                          color="info"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMedicationInfo(med);
                          }}
                          sx={{ ml: 'auto' }}
                        >
                          <Info fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>

                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleSelectMedication(med)}
                      >
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={medications.filter((med) =>
            med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
          ).length}
          page={medPage}
          onPageChange={(e, newPage) => setMedPage(newPage)}
          rowsPerPage={medRowsPerPage}
          onRowsPerPageChange={(e) => {
            setMedRowsPerPage(parseInt(e.target.value, 10));
            setMedPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Medication Request Form (Column 2) --- */}
    <Grid item xs={12} md={4} size={3}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Medication Request
        </Typography>

       <TextField
          label="Selected Medication"
          value={selectedMed?.name || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // text color
              opacity: 1,                    // remove dim
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                 // label color
              opacity: 1,
            }
          }}
        />

        <TextField
          label="Medication Status"
          value={selectedMed?.status || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",
              opacity: 1,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",
              opacity: 1,
            }
          }}
        />


        <FormControlLabel
          control={
            <Checkbox
              checked={autoCalculate}
              onChange={(e) => setAutoCalculate(e.target.checked)}
              size="big"
            />
          }
          label={<Typography fontSize="0.8rem">Auto Calculate Quantity</Typography>}
          sx={{ mb: 1 }}
        />

        
          
            <TextField
              label="Dose Amount"
              type="text"
              value={doseAmount}
              onChange={(e) => {
                setDoseAmount(e.target.value);
                if (e.target.value) setDoseAmountError(false);
              }}
              fullWidth
              size="big"
              margin="dense"
              error={doseAmountError}
              helperText={doseAmountError ? "Required" : ""}
            />
          
          
            <TextField
              label="Dose Unit"
              placeholder="ml, mg, tab"
              value={doseUnit}
              onChange={(e) => setDoseUnit(e.target.value)}
              fullWidth
              size="big"
              margin="dense"
            />
          
      
        <FormControl fullWidth margin="dense" size="big" error={frequencyError}>
          <InputLabel>Frequency</InputLabel>
          <Select
            value={frequency}
            onChange={(e) => {
              setFrequency(e.target.value);
              if (e.target.value) setFrequencyError(false);
            }}
          >
            {standardFrequencies.map((freq) => (
              <MenuItem key={freq} value={freq} sx={{ fontSize: "0.85rem" }}>
                {freq}
              </MenuItem>
            ))}
          </Select>
          {frequencyError && <FormHelperText>Required</FormHelperText>}
        </FormControl>

        <TextField
          label="Days"
          type="number"
          value={days}
          onChange={(e) => {
            const val = Number(e.target.value);
            setDays(val);
            if (val > 0) setDaysError(false);
          }}
          fullWidth
          size="big"
          margin="dense"
          error={daysError}
          helperText={daysError ? "Must be > 0" : ""}
        />

        <FormControl fullWidth margin="dense" size="big" error={routeError}>
          <InputLabel>Route</InputLabel>
          <Select
            value={route}
            onChange={(e) => {
              setRoute(e.target.value);
              if (e.target.value) setRouteError(false);
            }}
          >
            {MEDICATION_ROUTES.map((rt) => (
              <MenuItem key={rt} value={rt} sx={{ fontSize: "0.85rem" }}>
                {rt}
              </MenuItem>
            ))}
          </Select>
          {routeError && <FormHelperText>Required</FormHelperText>}
        </FormControl>

         <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="big"
          margin="dense"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // makes text black
              opacity: 1,                     // full visibility
            },

            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                // label color readable
              opacity: 1,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            }
          }}
        />

        <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
          <Button 
            fullWidth 
            variant="contained" 
            size="small" 
            onClick={handleAddMedication}
          >
            Make Request
          </Button>
          <Button 
            fullWidth 
            variant="outlined" 
            color="error" 
            size="small"
            onClick={handleClearMedication}
          >
            Clear
          </Button>
        </Stack>
      </Paper>
    </Grid>

    {/* --- Requested Medications (Column 3) --- */}
    <Grid item xs={12} md={4} size={6}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Requested Medications
        </Typography>

        <TableContainer sx={{ maxHeight: 350 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {["Drug", "Dose", "Freq", "Days", "Qty", "Route", "Cost"].map((col) => (
                  <TableCell
                    key={col}
                    sx={{ fontSize: "0.8rem", fontWeight: "bold", py: 0.5 }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedMeds
                .slice(reqMedPage * reqMedRowsPerPage, reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage)
                .map((req, idx) => (
                  <TableRow key={idx} sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.drug}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.dose}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.freq}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.days}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.qty}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.route}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>GH₵ {req.cost}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedMeds.length}
          page={reqMedPage}
          onPageChange={(e, newPage) => setReqMedPage(newPage)}
          rowsPerPage={reqMedRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqMedRowsPerPage(parseInt(e.target.value, 10));
            setReqMedPage(0);
          }}
          rowsPerPageOptions={[10, 20, 35]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #f3e5f5, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Pending: GH₵{" "}
            {formatWithOutSom(requestedMeds.filter((r) => r.status === "pending").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Paid: GH₵{" "}
            {formatWithOutSom (requestedMeds.filter((r) => r.status === "paid").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/* Other Serivces --*/}
{activeTab === 4 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Services (Left) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Non Insured Services
        </Typography>

        <TextField
          fullWidth
          placeholder="Search  Non Insured Services by name..."
          value={serviceSearchTerm}
          onChange={(e) => setServiceSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="big"
        />
        

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
           <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Quantity</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                Request
              </TableCell>
            </TableRow>
          </TableHead>

           <TableBody>
  {services
    .filter((srv) =>
      srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
    )
    .slice(servicePage * serviceRowsPerPage, servicePage * serviceRowsPerPage + serviceRowsPerPage)
    .map((srv, idx) => {
      const key = `${srv.name}-${idx}`;
      const quantity = serviceQuantities[key] || 1;
      const finalAmount = srv.amount * quantity;

      return (
        <TableRow key={key}>
          {/* Service Name */}
          <TableCell>{srv.name}</TableCell>

          {/* Quantity Input */}
          <TableCell>
            <TextField
              type="number"
              size="small"
              value={quantity}
              inputProps={{ min: 1 }}
              onChange={(e) => {
                const val = Math.max(1, Number(e.target.value));
                setServiceQuantities((prev) => ({ ...prev, [key]: val }));
              }}
              sx={{ width: 80 }}
            />
          </TableCell>

          {/* Auto-updated Amount */}
          <TableCell>{formatWithOutSom(finalAmount)}</TableCell>

          {/* Request Button */}
          <TableCell align="center">
            <IconButton
              color="primary"
              onClick={() =>
                handleRequestService({
                  ...srv,
                  amount: finalAmount,     // 👈 send multiplied amount
                  quantity,
                })
              }
            >
              <Send />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    })}
</TableBody>

          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={services.filter((srv) =>
            srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
          ).length}
          page={servicePage}
          onPageChange={(e, newPage) => setServicePage(newPage)}
          rowsPerPage={serviceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setServiceRowsPerPage(parseInt(e.target.value, 10));
            setServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>

      <Paper
      elevation={2}
      sx={{
        mt: 2,
        p: 2,
        borderRadius: 3,
        background: "linear-gradient(135deg,#fdfbfb 0%,#ebedee 100%)"
      }}
    >
      <Typography fontWeight={600} mb={2}>
        Request Service Not Listed
      </Typography>

      <Grid container spacing={2} alignItems="center" columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={12} md={5} size={6}>
          <TextField
            fullWidth
            size="small"
            label="Service Name"
            value={manualServiceName}
            onChange={(e) => setManualServiceName(e.target.value)}
          />
        </Grid>


        <Grid item xs={12} md={3} size={3}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label="Amount"
            value={manualAmount}
            onChange={(e) => setManualAmount(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={2} size={3}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<Send />}
            onClick={handleManualServiceRequest}
            sx={{
              height: 40,
              background:
                "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
              borderRadius: 2
            }}
          >
            Request
          </Button>
        </Grid>
      </Grid>
    </Paper>

    </Grid>

    {/* --- Requested Services (Right) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Services
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedServices
                .slice(
                  reqServicePage * reqServiceRowsPerPage,
                  reqServicePage * reqServiceRowsPerPage + reqServiceRowsPerPage
                )
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.service}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.servicedBy || "-"}</TableCell>
                    <TableCell>
                      <IconButton
                        color="error"
                        size="small"
                       
                        onClick={() => handleDeleteServiceRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedServices.length}
          page={reqServicePage}
          onPageChange={(e, newPage) => setReqServicePage(newPage)}
          rowsPerPage={reqServiceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqServiceRowsPerPage(parseInt(e.target.value, 10));
            setReqServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e1f5fe, #f1f8e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/*-- Approintment --*/}

{activeTab === 5 && (
  <Box>
    <Grid container spacing={3}>

      {/* ---------- APPOINTMENT FORM ONLY ---------- */}
      <Grid item xs={12} >
        <Paper sx={{ p: 3 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, mb: 3 }}
            color="primary"
          >
            {editingAppointmentId ? "Update Appointment" : "Book New Appointment"}
          </Typography>

          <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={12} sm={6} size={6}>
              <TextField
                fullWidth
                label="Appointment Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={appointmentDate}
                onChange={(e) => setAppointmentDate(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} size={6}>
              <TextField
                fullWidth
                label="Time"
                type="time"
                InputLabelProps={{ shrink: true }}
                value={appointmentTime}
                onChange={(e) => setAppointmentTime(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Type of Appointment</InputLabel>
                <Select
                  value={appointmentType}
                  onChange={(e) => setAppointmentType(e.target.value)}
                  label="Type of Appointment"
                >
                  <MenuItem value="Consultation">Consultation</MenuItem>
                  <MenuItem value="Review">Review</MenuItem>
                  <MenuItem value="Procedure">Procedure</MenuItem>
                  <MenuItem value="Telemedicine">Telemedicine</MenuItem>
                  <MenuItem value="Follow-up">Follow-up</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} size={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendReminder}
                    onChange={(e) => setSendReminder(e.target.checked)}
                  />
                }
                label="Send Reminder"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <TextField
                fullWidth
                label="Reason for Appointment"
                multiline
                rows={3}
                value={appointmentReason}
                onChange={(e) => setAppointmentReason(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <TextField
                fullWidth
                label="Other Information"
                multiline
                rows={3}
                value={appointmentOther}
                onChange={(e) => setAppointmentOther(e.target.value)}
                size="small"
              />
            </Grid>

            {/* SAVE or UPDATE BUTTON */}
            <Grid item xs={12} size={6}>
              <Button
                variant="contained"
                color={editingAppointmentId ? "warning" : "primary"}
                startIcon={<SaveIcon />}
                onClick={handleSaveAppointment}
              >
                {editingAppointmentId ? "Update Appointment" : "Save Appointment"}
              </Button>
            </Grid>

            {/* DELETE BUTTON — Only visible in edit mode */}
            {editingAppointmentId && (
              <Grid item xs={12} size={6}>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<Delete />}
                  onClick={() => handleDeleteAppointment(editingAppointmentId)}
                  sx={{ ml: 2 }}
                >
                  Delete Appointment
                </Button>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  </Box>
)}


{activeTab === 6 && (
  <Box>
    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
      Admit Patient
    </Typography>

    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* ---------- Row 1: Complaint, History, Physical Exam, Other Document ---------- */}
      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="Complaint"
          multiline
          rows={4}
          value={complaint}
          disabled
          onChange={(e) => setComplaint(e.target.value)}
          placeholder="Enter patient's complaint..."
        />
      </Grid>

      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="History"
          multiline
          rows={4}
          value={history}
          disabled
          onChange={(e) => setHistory(e.target.value)}
          placeholder="Enter relevant patient history..."
        />
      </Grid>

      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="Physical Exam"
          multiline
          rows={4}
          value={exam}
          disabled
          onChange={(e) => setExam(e.target.value)}
          placeholder="Enter physical exam findings..."
        />
      </Grid>

      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="Other Document"
          multiline
          rows={4}
          value={other}
          disabled
          onChange={(e) => setOther(e.target.value)}
          placeholder="Enter other relevant notes or documents..."
        />
      </Grid>

      {/* ---------- Row 2: Diagnoses and Procedures ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Diagnoses
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedDiagnoses && selectedDiagnoses.length > 0 ? (
            selectedDiagnoses.map((diag, idx) => (
              <Chip key={idx} label={diag.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No diagnosis selected
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Procedures
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedProcedures && selectedProcedures.length > 0 ? (
            selectedProcedures.map((proc, idx) => (
              <Chip key={idx} label={proc.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No procedure selected
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 3: Laboratory & Scan Requested ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Laboratory Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedLabs.length > 0 ? (
            requestedLabs.map((lab, idx) => (
              <Chip key={idx} label={lab.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No lab requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Scan Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedScans.length > 0 ? (
            requestedScans.map((scan, idx) => (
              <Chip key={idx} label={scan.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No scan requested
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 4: Medications & Other Services ---------- */}
      <Grid item xs={12} md={6} size={9}>
        <Typography variant="subtitle1" fontWeight={600}>
          Medications Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedMeds.length > 0 ? (
            requestedMeds.map((med, idx) => (
              <Chip key={idx} label={med.drug} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No medication requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Other Services Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedServices.length > 0 ? (
            requestedServices.map((srv, idx) => (
              <Chip key={idx} label={srv.service} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No service requested
            </Typography>
          )}
        </Box>
      </Grid>


      {/* ---------- Row 4.5: Admission Status ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <FormControl fullWidth>
          <InputLabel id="admission-status-label">Admission Status</InputLabel>
          <Select
            labelId="admission-status-label"
            label="Admission Status"
            value={admissionStatus}
            onChange={(e) => setAdmissionStatus(e.target.value)}
          >
            <MenuItem value="Admission">Admission</MenuItem>
            <MenuItem value="Detention">Detention</MenuItem>
             <MenuItem value="Emergency">Emergency</MenuItem>
          </Select>
        </FormControl>
      </Grid>


      {/* ---------- Row 5: Date & Time of Admission ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <TextField
          fullWidth
          label="Date of Admission"
          type="date"
          value={admissionDate}
          disabled
          onChange={(e) => setAdmissionDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6}size={2}>
        <TextField
          fullWidth
          label="Time of Admission"
          type="time"
          value={admissionTime}
          onChange={(e) => setAdmissionTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* ---------- Row 6: Admission Note & Treatment Plan ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Reason for Admission"
          multiline
          rows={5}
          value={admissionNote}
          onChange={(e) => setAdmissionNote(e.target.value)}
          placeholder="Enter detailed admission Reason /  note..."
        />
      </Grid>
      
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Treatment Plan"
          multiline
          rows={5}
          value={treatmentPlan}
          onChange={(e) => setTreatmentPlan(e.target.value)}
          placeholder="Enter treatment plan..."
        />
      </Grid>
    </Grid>

    {/* Submit / Admit Button */}
    <Box sx={{ textAlign: "right", mt: 3 }}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<Hotel />}
    onClick={() => {
      if (!validateAdmissionForm()) return;

      // 👉 Submit to backend
      submitAdmission();
      }}
  >
    Admit Patient
  </Button>

    </Box>
  </Box>
)}    

</Paper>
  </Box>
) : (
  <Paper
    sx={{
      p: 6,
      textAlign: "center",
      height: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box>
      <Person sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        Search and select a patient to begin consultation
      </Typography>
    </Box>
  </Paper>
)}



<Dialog open={medDialogOpen} onClose={() => setMedDialogOpen(false)} maxWidth="lx" fullWidth>
  <DialogTitle>Medication Full View</DialogTitle>
  <DialogContent>
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* --- Available Medications (Column 1) --- */}
      <Grid item xs={12} md={4} size={3}>
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Available Medications
          </Typography>

          <TextField
            fullWidth
            placeholder="Search medication..."
            value={medSearchTerm}
            onChange={(e) => setMedSearchTerm(e.target.value)}
            size="big"
            margin="dense"
            sx={{ mb: 1 }}
          />

          <TableContainer sx={{ maxHeight: 600 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Medication</TableCell>
                  <TableCell align="center">Select</TableCell>
                </TableRow>
              </TableHead>
              {/* In the Dialog - Available Medications */}
            <TableBody>
              {medications
                .filter((med) =>
                  med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
                )
                .slice(medPage * medRowsPerPage, medPage * medRowsPerPage + medRowsPerPage)
                .map((med, idx) => (
                  <TableRow 
                    key={idx}
                    sx={{ 
                      "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
                      // ✅ Highlight chronic medications
                      backgroundColor: isMedicationChronic(med.name) ? '#e8f5e9' : 'inherit',
                      borderLeft: isMedicationChronic(med.name) ? '4px solid #4caf50' : 'none',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: isMedicationChronic(med.name) ? '#c8e6c9' : 'action.hover',
                      }
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {med.name}
                        {isMedicationChronic(med.name) && (
                          <Chip 
                            label="Chronic drug" 
                            size="small" 
                            color="success" 
                            sx={{ 
                              height: 20, 
                              fontSize: '0.65rem',
                              fontWeight: 600
                            }} 
                          />
                        )}
                        <Tooltip title="Medication Info">
                          <IconButton
                            size="small"
                            color="info"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMedicationInfo(med);
                            }}
                            sx={{ ml: 'auto' }}
                          >
                            <Info fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleSelectMedication(med)}
                      >
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={medications.filter((med) =>
              med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
            ).length}
            page={medPage}
            onPageChange={(e, newPage) => setMedPage(newPage)}
            rowsPerPage={medRowsPerPage}
            onRowsPerPageChange={(e) => {
              setMedRowsPerPage(parseInt(e.target.value, 10));
              setMedPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
          />
        </Paper>
      </Grid>

      {/* --- Medication Request (Column 2) --- */}
      <Grid item xs={12} md={4} size={2} >
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Medication Request
          </Typography>

          {/* Selected Medication */}
           <TextField
          label="Selected Medication"
          value={selectedMed?.name || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // text color
              opacity: 1,                    // remove dim
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                 // label color
              opacity: 1,
            }
          }}
        />

        <TextField
          label="Medication Status"
          value={selectedMed?.status || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",
              opacity: 1,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",
              opacity: 1,
            }
          }}
        />

          {/* Auto Calculate Toggle */}
          <FormControlLabel
            control={
              <Checkbox
                checked={autoCalculate}
                onChange={(e) => setAutoCalculate(e.target.checked)}
                size="big"
              />
            }
            label="Auto Calculate Quantity"
            sx={{ mb: 1 }}
          />

              <TextField
                label="Dose Amount"
                type="text"
                value={doseAmount}
                onChange={(e) => setDoseAmount(e.target.value)}
                fullWidth
                size="big"
                margin="dense"
              />
           
            
              <TextField
                label="Dose Unit"
                value={doseUnit}
                onChange={(e) => setDoseUnit(e.target.value)}
                fullWidth
                size="big"
                margin="dense"
              />

          {/* Frequency */}
          <FormControl fullWidth margin="dense" size="big">
            <InputLabel>Frequency</InputLabel>
            <Select
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
            >
              {standardFrequencies.map((freq) => (
                <MenuItem key={freq} value={freq}>{freq}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Days */}
          <TextField
            label="Days"
            type="number"
            value={days}
            onChange={(e) => setDays(Number(e.target.value))}
            fullWidth
            size="big"
            margin="dense"
          />

          {/* Route */}
          <FormControl fullWidth margin="dense" size="big">
            <InputLabel>Route</InputLabel>
            <Select value={route} onChange={(e) => setRoute(e.target.value)}>
              {MEDICATION_ROUTES.map((rt) => (
                <MenuItem key={rt} value={rt}>{rt}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Quantity */}
         <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="big"
          margin="dense"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // makes text black
              opacity: 1,                     // full visibility
            },

            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                // label color readable
              opacity: 1,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            }
          }}
        />


          {/* Buttons (Update or Add) */}
          <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
            {editingIndex !== null ? (
              <Button fullWidth variant="contained" size="small" color="success" onClick={handleUpdateMedication}>
                Update Request
              </Button>
            ) : (
              <Button fullWidth variant="contained" size="small" onClick={handleAddMedication}>
                Make Request
              </Button>
            )}
            <Button
              fullWidth
              variant="outlined"
              color="error"
              size="big"
              onClick={handleClearMedication}
            >
              Clear
            </Button>
          </Stack>
        </Paper>
      </Grid>

      {/* --- Requested Medications (Column 3) --- */}
      <Grid item xs={12} md={4} size={7}>
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Requested Medications
          </Typography>

          <TableContainer sx={{ maxHeight: 600 }}>
            <Table size="big" stickyHeader>
              <TableHead>
                <TableRow>
                  {["Date", "Drug", "Dose", "Freq", "Days", "Qty", "Route", "Cost", "Requested By", "Served By", "Status", "Action"].map((col) => (
                    <TableCell key={col}>{col}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {requestedMeds
                  .slice(reqMedPage * reqMedRowsPerPage, reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage)
                  .map((req, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{req.date}</TableCell>
                      <TableCell>{req.drug}</TableCell>
                      <TableCell>{req.dose}</TableCell>
                      <TableCell>{req.freq}</TableCell>
                      <TableCell>{req.days}</TableCell>
                      <TableCell>{req.qty}</TableCell>
                      <TableCell>{req.route}</TableCell>
                      <TableCell>{req.cost}</TableCell>
                      <TableCell>{req.requestedBy || "Doctor A"}</TableCell>
                      <TableCell>{req.servedBy || "-"}</TableCell>
                      <TableCell sx={{ color: req.status === "paid" ? "green" : "orange" }}>
                        {req.status} 
                      </TableCell>
                     <TableCell>
                      <>
                        {/* Chronic Refill Icon */}
                        <Tooltip title="Chronic Medication Refill">
                          <IconButton
                            size="small"
                            color="secondary"
                            onClick={() => handleChronicRefill(req)}  // <— create this function
                          >
                            <LocalHospitalIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Edit Medication */}
                        {req.status === "pending" && (
                          <Tooltip title="Edit Medication Request">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleEditMedication(idx)}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Delete Medication */}
                        <Tooltip title="Delete Medication Request">
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteMedication(req)}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </>
                    </TableCell>

                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={requestedMeds.length}
            page={reqMedPage}
            onPageChange={(e, newPage) => setReqMedPage(newPage)}
            rowsPerPage={reqMedRowsPerPage}
            onRowsPerPageChange={(e) => {
              setReqMedRowsPerPage(parseInt(e.target.value, 10));
              setReqMedPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
          />
          {/* Totals */}
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #f3e5f5, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Pending: GH₵{" "}
            {formatWithOutSom (requestedMeds.filter((r) => r.status === "pending").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Paid: GH₵{" "}
            {formatWithOutSom(requestedMeds.filter((r) => r.status === "paid").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
        </Box>
        </Paper>
      </Grid>
    </Grid>
  </DialogContent>
</Dialog>


{/* Medication Information Dialog */}
<Dialog 
  open={medInfoDialogOpen} 
  onClose={() => {
    setMedInfoDialogOpen(false);
    setMedInfoLoading(false); // ✅ Reset loading on close
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
    <Box display="flex" alignItems="center" gap={1}>
      <Medication />
      <Typography variant="h6">Medication Information</Typography>
    </Box>
  </DialogTitle>
  
  <DialogContent sx={{ mt: 2, minHeight: 300 }}>
    {selectedMedInfo ? (
      <Box>
        {/* Medication Name */}
        <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
          <Typography variant="h6" fontWeight={600} color="primary">
            {selectedMedInfo.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Code: {selectedMedInfo.code || 'N/A'}
          </Typography>
        </Paper>

        {/* Status & Pricing */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                Status
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                <Chip 
                  label={selectedMedInfo.status} 
                  color={selectedMedInfo.status === 'Non Insured' ? 'warning' : 'success'}
                  sx={{ mt: 1 }}
                />
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={6}>
            <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                Unit Of Pricing
              </Typography>
              <Typography variant="h6" fontWeight={600} color="success.main" sx={{ mt: 1 }}>
                 {selectedMedInfo.pricing}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Stock Information */}
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
          Stock Availability
        </Typography>

        {/* ✅ Show loading or stock info */}
        {medInfoLoading ? (
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center',
              minHeight: 200,
              gap: 2
            }}
          >
            <CircularProgress size={50} thickness={4} />
            <Typography variant="body2" color="text.secondary">
              Loading stock information...
            </Typography>
          </Box>
        ) : (
          <>
            {/* Dispensary Stock */}
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2, 
                mb: 2,
                border: '2px solid',
                borderColor: 'primary.main',
                bgcolor: '#e3f2fd'
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Dispensary Stock
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Available for immediate dispensing
                  </Typography>
                </Box>
                <Chip
                  label={`${selectedMedInfo.dispensary_stock || 0} units`}
                  color={
                    (selectedMedInfo.dispensary_stock || 0) > 50 
                      ? 'success' 
                      : (selectedMedInfo.dispensary_stock || 0) > 0 
                        ? 'warning' 
                        : 'error'
                  }
                  sx={{ 
                    fontWeight: 700,
                    fontSize: '1rem',
                    height: 36,
                    minWidth: 100
                  }}
                />
              </Box>
            </Paper>

            {/* Store Stock */}
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2,
                border: '2px solid',
                borderColor: 'secondary.main',
                bgcolor: '#f3e5f5'
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Store Stock
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Main inventory
                  </Typography>
                </Box>
                <Chip
                  label={
                    (selectedMedInfo.store_stock || 0) > 0 
                      ? 'In Stock' 
                      : 'Out of Stock'
                  }
                  color={(selectedMedInfo.store_stock || 0) > 0 ? 'success' : 'error'}
                  sx={{ 
                    fontWeight: 700,
                    fontSize: '1rem',
                    height: 36,
                    minWidth: 100
                  }}
                />
              </Box>
            </Paper>

            {/* Low Stock Warning */}
            {(selectedMedInfo.dispensary_stock || 0) < 10 && (selectedMedInfo.dispensary_stock || 0) > 0 && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#fff3e0',
                  borderRadius: 1,
                  border: '1px solid #ff9800'
                }}
              >
                <Typography variant="body2" color="warning.dark" fontWeight={600}>
                  ⚠️ Low Stock Alert: Please restock soon
                </Typography>
              </Box>
            )}

            {/* Out of Stock Warning */}
            {(selectedMedInfo.dispensary_stock || 0) === 0 && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#ffebee',
                  borderRadius: 1,
                  border: '1px solid #f44336'
                }}
              >
                <Typography variant="body2" color="error.dark" fontWeight={600}>
                  ❌ Out of Stock: Cannot dispense at this time
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    ) : (
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: 300
        }}
      >
        <CircularProgress />
      </Box>
    )}
  </DialogContent>
  
  <DialogActions>
    <Button 
      onClick={() => {
        setMedInfoDialogOpen(false);
        setMedInfoLoading(false); // ✅ Reset loading
        setSelectedMedInfo(null); // ✅ Clear data
      }} 
      variant="contained"
      disabled={medInfoLoading} // ✅ Disable while loading
    >
      Close
    </Button>
  </DialogActions>
</Dialog>


{/* ALL History */}
<MedicalHistoryDialog
  open={medHistoryOpen}
  onClose={() => setMedHistoryOpen(false)}
  patientData={selectedPatient}
/>

{/* lab History */}
<LabHistoryDialog
  open={labHistoryOpen}
  onClose={() => setlabHistoryOpen(false)}
  patientData={selectedPatient}
/>


{/* Scan History */}
<ScanHistoryDialog
  open={ScanHistoryOpen}
  onClose={() => setScanHistoryOpen(false)}
  patientData={selectedPatient}
/>


<VitalsHistoryDialog
  open={vitalsHistoryOpen}
  onClose={() => setVitalsHistoryOpen(false)}
  patientData={selectedPatient}
/>


 {/* Medication History */}
    <MedicationHistory
        open={openmedHis}
        onClose={() => setopenmedHis(false)}
        id={selectedPatient ? selectedPatient.id: ''}
       // onSubmit={getCCCData}
     />

  
  <SpecialPrecautionDialog
  open={precautionDialogOpen}
  onClose={() => setPrecautionDialogOpen(false)}
  patient={selectedPatient}
/>


<ChronicMedicationDialog
  open={chronicDialogOpen}
  onClose={() => setChronicDialogOpen(false)}
  meds={chronicMeds}

/>




<Dialog
  open={labResultsDialogOpen}
  onClose={() => setLabResultsDialogOpen(false)}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: { height: '90vh', borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }
  }}
>
  <DialogTitle sx={{ p: 0 }}>
    <Box
      sx={{
        px: 3, py: 2,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        color: 'white'
      }}
    >
      <Box>
        <Typography variant="h6" fontWeight={700}>Enter Laboratory Results</Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          {selectedLabForResults?.lab}
        </Typography>
      </Box>
      <IconButton onClick={() => setLabResultsDialogOpen(false)} sx={{ color: 'white' }}>
        <Close />
      </IconButton>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ bgcolor: '#f1fcf9', p: 3 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

      {/* Row 1: Parameters + Entry Form */}
      <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

        {/* Parameters List */}
        <Grid item xs={12} md={6} size={6}>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #c8e6c9', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: 2,
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontWeight: 700
              }}>1</Box>
              <Box>
                <Typography variant="subtitle1" fontWeight={700} color="#1b5e20">Select Parameter</Typography>
                {testCategory && (
                  <Typography variant="caption" color="text.secondary">Category: {testCategory}</Typography>
                )}
              </Box>
            </Box>

            {loadingParameters ? (
              <Box display="flex" justifyContent="center" p={4}><CircularProgress sx={{ color: '#11998e' }} /></Box>
            ) : (
              <Box sx={{ maxHeight: 380, overflow: 'auto', border: '1px solid #c8e6c9', borderRadius: 2, bgcolor: '#f1fcf9' }}>
                {testParameters.map((param, idx) => (
                  <Box
                    key={idx}
                    onClick={() => editingResultIndex === null && handleParameterSelectForLab(param)}
                    sx={{
                      px: 2, py: 1.5,
                      cursor: editingResultIndex !== null ? 'default' : 'pointer',
                      opacity: editingResultIndex !== null ? 0.5 : 1,
                      borderBottom: '1px solid #e8f5e9',
                      bgcolor: selectedParameter?.test === param.test
                        ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
                        : 'transparent',
                      background: selectedParameter?.test === param.test
                        ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
                        : 'transparent',
                      color: selectedParameter?.test === param.test ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: selectedParameter?.test === param.test ? undefined : '#f1fcf9'
                      }
                    }}
                  >
                    <Typography fontWeight={600} fontSize="0.9rem">{param.test}</Typography>
                    <Typography variant="caption" sx={{
                      color: selectedParameter?.test === param.test ? 'rgba(255,255,255,0.8)' : 'text.secondary'
                    }}>Category: {param.cat}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Paper>
        </Grid>

        {/* Entry Form */}
        <Grid item xs={12} md={6} size={6}>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #c8e6c9', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: 2,
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontWeight: 700
              }}>2</Box>
              <Typography variant="subtitle1" fontWeight={700} color="#1b5e20">Enter Result</Typography>
            </Box>

            <Stack spacing={2}>
              <TextField fullWidth size="small" label="Selected Parameter"
                value={selectedParameter?.test || ''} InputProps={{ readOnly: true }}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#f1fcf9' } }}
              />
              <TextField fullWidth size="small" label="Unit"
                value={selectedParameter?.unit || ''}
                onChange={(e) => selectedParameter && setSelectedParameter({ ...selectedParameter, unit: e.target.value })}
              />
              <TextField fullWidth size="small" label="Reference Range"
                value={selectedParameter ? getLabParameterRange(selectedParameter) : ''}
                onChange={(e) => {
                  if (!selectedParameter) return;
                  const gender = selectedPatient?.gender?.toUpperCase();
                  const updated = { ...selectedParameter };
                  if (gender === 'MALE') updated.male = e.target.value;
                  else if (gender === 'FEMALE') updated.female = e.target.value;
                  else updated.children = e.target.value;
                  setSelectedParameter(updated);
                }}
              />
              <FormControl fullWidth size="small">
                <InputLabel>Flag</InputLabel>
                <Select value={parameterFlag} label="Flag" onChange={(e) => handleLabFlagChange(e.target.value)}>
                  {availableFlags.map(f => (
                    <MenuItem key={f} value={f}>{f === 'Select/Enter' ? f : f.charAt(0).toUpperCase() + f.slice(1)}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField fullWidth size="small" label="Result Value"
                value={parameterResult}
                onChange={(e) => handleLabResultChange(e.target.value)}
                autoFocus
                sx={{ '& .MuiOutlinedInput-root': { fontWeight: 700, fontSize: '1.1rem' } }}
              />

              <Button
                variant="contained" fullWidth
                onClick={handleAddLabResult}
                disabled={!selectedParameter || !parameterResult.trim()}
                sx={{
                  py: 1.5, borderRadius: 2,
                  background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                  fontWeight: 600, textTransform: 'none',
                  '&:disabled': { background: '#e0e0e0' }
                }}
              >
                {editingResultIndex !== null ? 'Update Result' : '+ Add Result'}
              </Button>

              {editingResultIndex !== null ? (
                <Button variant="outlined" fullWidth onClick={handleCancelLabEdit}
                  sx={{ borderColor: '#11998e', color: '#11998e', textTransform: 'none' }}>
                  Cancel Edit
                </Button>
              ) : (
                <Button variant="outlined" fullWidth
                  onClick={() => { setSelectedParameter(null); setParameterResult(''); setParameterFlag('Select/Enter'); }}
                  sx={{ borderColor: '#c8e6c9', color: '#666', textTransform: 'none' }}>
                  Clear
                </Button>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>

      {/* Row 2: Results Table */}
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #c8e6c9' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box sx={{
            width: 36, height: 36, borderRadius: 2,
            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'white', fontWeight: 700
          }}>3</Box>
          <Typography variant="subtitle1" fontWeight={700} color="#1b5e20">
            Results ({enteredResults.length})
          </Typography>
        </Box>

        <TableContainer sx={{ maxHeight: 250, border: '1px solid #c8e6c9', borderRadius: 2 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {['Parameter', 'Result', 'Unit', 'Range', 'Flag', 'Actions'].map(h => (
                  <TableCell key={h} sx={{ fontWeight: 700, color: '#1b5e20', bgcolor: '#f1fcf9', fontSize: '0.8rem' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {enteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                    <Typography color="text.secondary" variant="body2">No results added yet</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                enteredResults.map((r, idx) => (
                  <TableRow key={idx} hover>
                    <TableCell sx={{ fontWeight: 600, fontSize: '0.8rem' }}>{r.parameterName}</TableCell>
                    <TableCell sx={{
                      fontWeight: 700, fontSize: '0.85rem',
                      color: r.flag === 'normal' ? '#2e7d32' : r.flag === 'high' ? '#d32f2f' : r.flag === 'low' ? '#ed6c02' : 'inherit'
                    }}>{r.result}</TableCell>
                    <TableCell sx={{ fontSize: '0.8rem' }}>{r.unit}</TableCell>
                    <TableCell sx={{ fontSize: '0.8rem' }}>{r.range}</TableCell>
                    <TableCell>
                      <Chip label={r.flag} size="small" sx={{
                        fontWeight: 600, fontSize: '0.7rem',
                        bgcolor: r.flag === 'normal' ? 'rgba(46,125,50,0.1)' : r.flag === 'high' ? 'rgba(211,47,47,0.1)' : r.flag === 'low' ? 'rgba(237,108,2,0.1)' : 'rgba(0,0,0,0.08)',
                        color: r.flag === 'normal' ? '#2e7d32' : r.flag === 'high' ? '#d32f2f' : r.flag === 'low' ? '#ed6c02' : 'inherit'
                      }} />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <IconButton size="small" onClick={() => handleEditLabResult(idx)}
                          disabled={editingResultIndex !== null} sx={{ color: '#11998e' }}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleRemoveLabResult(r)}
                          disabled={editingResultIndex !== null} sx={{ color: '#d32f2f' }}>
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Row 3: General Comments */}
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #c8e6c9' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box sx={{
            width: 36, height: 36, borderRadius: 2,
            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'white', fontWeight: 700
          }}>4</Box>
          <Typography variant="subtitle1" fontWeight={700} color="#1b5e20">General Comments</Typography>
        </Box>
        <TextField
          fullWidth multiline rows={3}
          label="Additional Notes"
          value={generalComment}
          onChange={(e) => setGeneralComment(e.target.value)}
          placeholder="Enter any comments or observations..."
        />
      </Paper>
    </Box>
  </DialogContent>

  <DialogActions sx={{ p: 2, bgcolor: '#f1fcf9', gap: 2 }}>
    <Button onClick={() => setLabResultsDialogOpen(false)} sx={{ color: '#666', fontWeight: 600, textTransform: 'none' }}>
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={handleSaveLabResults}
      disabled={enteredResults.length === 0}
      sx={{
        px: 4, py: 1, borderRadius: 2,
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        fontWeight: 600, textTransform: 'none',
        '&:disabled': { background: '#e0e0e0' }
      }}
    >
      Save All Results ({enteredResults.length})
    </Button>
  </DialogActions>
</Dialog>






{/* Scan Results Entry Dialog */}
<Dialog
  open={scanResultsDialogOpen}
  onClose={() => setScanResultsDialogOpen(false)}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: { height: '90vh', borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }
  }}
>
  <DialogTitle sx={{ p: 0 }}>
    <Box
      sx={{
        px: 3, py: 2,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}
    >
      <Box>
        <Typography variant="h6" fontWeight={700}>Enter Scan Results</Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          {selectedScanForResults?.lab}
        </Typography>
      </Box>
      <IconButton onClick={() => setScanResultsDialogOpen(false)} sx={{ color: 'white' }}>
        <Close />
      </IconButton>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ bgcolor: '#f8f9fd', p: 3 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

      {/* Row 1: Parameters + Entry Form */}
      <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

        {/* Parameters List */}
        <Grid item xs={12} md={6} size={6}>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e8eaf6', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: 2,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontWeight: 700
              }}>1</Box>
              <Typography variant="subtitle1" fontWeight={700} color="#3949ab">Select Parameter</Typography>
            </Box>

            {loadingScanParameters ? (
              <Box display="flex" justifyContent="center" p={4}>
                <CircularProgress sx={{ color: '#667eea' }} />
              </Box>
            ) : (
              <Box sx={{ maxHeight: 380, overflow: 'auto', border: '1px solid #e8eaf6', borderRadius: 2, bgcolor: '#f8f9fd' }}>
                {scanTestParameters.map((param, idx) => (
                  <Box
                    key={idx}
                    onClick={() => editingScanResultIndex === null && handleScanParameterSelect(param)}
                    sx={{
                      px: 2, py: 1.5,
                      cursor: editingScanResultIndex !== null ? 'default' : 'pointer',
                      opacity: editingScanResultIndex !== null ? 0.5 : 1,
                      borderBottom: '1px solid #e8eaf6',
                      background: selectedScanParameter?.id === param.id
                        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        : 'transparent',
                      color: selectedScanParameter?.id === param.id ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: selectedScanParameter?.id === param.id ? undefined : '#f0f1fa'
                      }
                    }}
                  >
                    <Typography fontWeight={600} fontSize="0.9rem">{param.name}</Typography>
                    {param.flags && param.flags.length > 0 && (
                      <Typography variant="caption" sx={{
                        color: selectedScanParameter?.id === param.id ? 'rgba(255,255,255,0.8)' : 'text.secondary'
                      }}>Flags: {param.flags.join(', ')}</Typography>
                    )}
                  </Box>
                ))}
                {scanTestParameters.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography color="text.secondary" variant="body2">No parameters found for this scan</Typography>
                  </Box>
                )}
              </Box>
            )}
          </Paper>
        </Grid>

        {/* Entry Form */}
        <Grid item xs={12} md={6} size={6}>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e8eaf6', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: 2,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontWeight: 700
              }}>2</Box>
              <Typography variant="subtitle1" fontWeight={700} color="#3949ab">Enter Result</Typography>
            </Box>

            <Stack spacing={2}>
              <TextField fullWidth size="small" label="Selected Parameter"
                value={selectedScanParameter?.name || ''} InputProps={{ readOnly: true }}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#f8f9fd' } }}
              />

              <FormControl fullWidth size="small">
                <InputLabel>Flag</InputLabel>
                <Select 
                  value={scanParameterFlag} 
                  label="Flag" 
                  onChange={(e) => setScanParameterFlag(e.target.value)}
                >
                  {availableScanFlags.map(f => (
                    <MenuItem key={f} value={f.toLowerCase()}>
                      {f === '-' ? '-' : f.charAt(0).toUpperCase() + f.slice(1)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField 
                fullWidth 
                multiline 
                rows={4}
                label="Finding / Result"
                value={scanParameterResult}
                onChange={(e) => setScanParameterResult(e.target.value)}
                placeholder={selectedScanParameter ? `Enter result for ${selectedScanParameter.name}` : 'Select a parameter first'}
                autoFocus
              />

              <Button
                variant="contained" fullWidth
                onClick={handleAddScanResult}
                disabled={!selectedScanParameter || !scanParameterResult.trim()}
                sx={{
                  py: 1.5, borderRadius: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  fontWeight: 600, textTransform: 'none',
                  '&:disabled': { background: '#e0e0e0' }
                }}
              >
                {editingScanResultIndex !== null ? 'Update Result' : '+ Add Result'}
              </Button>

              {editingScanResultIndex !== null ? (
                <Button variant="outlined" fullWidth onClick={handleCancelScanEdit}
                  sx={{ borderColor: '#667eea', color: '#667eea', textTransform: 'none' }}>
                  Cancel Edit
                </Button>
              ) : (
                <Button variant="outlined" fullWidth
                  onClick={() => { setSelectedScanParameter(null); setScanParameterResult(''); setScanParameterFlag('-'); }}
                  sx={{ borderColor: '#e0e0e0', color: '#666', textTransform: 'none' }}>
                  Clear
                </Button>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>

      {/* Row 2: Results Table */}
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e8eaf6' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box sx={{
            width: 36, height: 36, borderRadius: 2,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'white', fontWeight: 700
          }}>3</Box>
          <Typography variant="subtitle1" fontWeight={700} color="#3949ab">
            Results ({enteredScanResults.length})
          </Typography>
        </Box>

        <TableContainer sx={{ maxHeight: 250, border: '1px solid #e8eaf6', borderRadius: 2 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {['Parameter', 'Finding/Result', 'Flag', 'Actions'].map(h => (
                  <TableCell key={h} sx={{ fontWeight: 700, color: '#3949ab', bgcolor: '#f8f9fd', fontSize: '0.8rem' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {enteredScanResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                    <Typography color="text.secondary" variant="body2">No results added yet</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                enteredScanResults.map((r, idx) => (
                  <TableRow key={idx} hover>
                    <TableCell sx={{ fontWeight: 600, fontSize: '0.85rem' }}>{r.parameterName}</TableCell>
                    <TableCell sx={{ fontSize: '0.85rem', maxWidth: 300, whiteSpace: 'pre-wrap' }}>{r.result}</TableCell>
                    <TableCell>
                      <Chip label={r.flag} size="small" 
                        color={r.flag === 'normal' || r.flag === '-' ? 'success' : 'warning'}
                        variant="outlined"
                        sx={{ fontWeight: 600, fontSize: '0.7rem' }} 
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <IconButton size="small" onClick={() => handleEditScanResult(idx)}
                          disabled={editingScanResultIndex !== null} sx={{ color: '#667eea' }}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleRemoveScanResult(idx)}
                          disabled={editingScanResultIndex !== null} sx={{ color: '#d32f2f' }}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Row 3: General Comments */}
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e8eaf6' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box sx={{
            width: 36, height: 36, borderRadius: 2,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'white', fontWeight: 700
          }}>4</Box>
          <Typography variant="subtitle1" fontWeight={700} color="#3949ab">General Comments</Typography>
        </Box>
        <TextField
          fullWidth multiline rows={3}
          label="Additional Notes or Impressions"
          value={scanGeneralComment}
          onChange={(e) => setScanGeneralComment(e.target.value)}
          placeholder="Enter any general comments or impressions..."
        />
      </Paper>
    </Box>
  </DialogContent>

  <DialogActions sx={{ p: 2, bgcolor: '#f8f9fd', gap: 2 }}>
    <Button onClick={() => setScanResultsDialogOpen(false)} sx={{ color: '#666', fontWeight: 600, textTransform: 'none' }}>
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={handleSaveScanResults}
      disabled={enteredScanResults.length === 0}
      sx={{
        px: 4, py: 1, borderRadius: 2,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        fontWeight: 600, textTransform: 'none',
        '&:disabled': { background: '#e0e0e0' }
      }}
    >
      Save All Results ({enteredScanResults.length})
    </Button>
  </DialogActions>
</Dialog>


 {selectedPatient && (
  <OutPatientWardRoundsDialog
    open={wardRoundsOpen}
    onClose={() => {
      setWardRoundsOpen(false);
      if (selectedPatient) {
        loadRequestedLabs();
        loadRequestedScan();
        loadRequestedMeds();
        loadrequestedServices();
      }
    }}
    patient={{
      name: selectedPatient?.fullName,
      id: selectedPatient?.id,
      age: selectedPatient?.age,
      gender: selectedPatient?.gender,
      phone: selectedPatient?.tel,
      insurance: selectedPatient?.insurance,
    }}
    fields={{
      startDate: selectedPatient?.visitDate,
      endDate: selectedPatient?.d_dat || null
    }}
    utils={{ suggestionsData, handleSuggest, setHasEdited }}
    diagnosisOptions={diagnosisOptions}
    selectedDiagnoses={selectedDiagnoses}
    setSelectedDiagnoses={setSelectedDiagnoses}
    saveOrUpdateDiagnosis={saveOrUpdateDiagnosis}
    procedureOptions={procedureOptions}
    selectedProcedures={selectedProcedures}
    setSelectedProcedures={setSelectedProcedures}
    saveOrUpdateProcedure={saveOrUpdateProcedure}
    insuranceName={selectedPatient?.insurance}
    // ─── NEW: pass consultation context ────────────────────────
    opdContext={{
      complaint,
      history,
      exam,
      other,
      isOPD: !selectedPatient?.d_dat 
    }}
  />
)}


</Container>
</Box>
  );
};

export default OutPatient;


